import { unwrap, toArray, some, flatten, map, defaultArg } from "../../fable_modules/fable-library-js.4.19.3/Option.js";
import { Permission, isAllowed } from "../../RAWMap.Models/Security.js";
import { mkToolReactButton, mkDispatchLocal } from "../Common/CommonView.js";
import { FormField_slider, FormField_labeledSlider, FormField_onChangeNumberDispatch, FormField_ReactSelectCallback$1, FormField_reactSelectSingle } from "../../Common/Forms.js";
import { SelectPropsMulti$1 } from "../../Common/ReactSelectBind.js";
import { LoadingStatus, ImageData_WallMasks__43A3F7B7, ImageData_LumenMasks__43A3F7B7, DicomViewMode_get_describe, ImageData_StandardImageFiles__43A3F7B7, ViewportLocation, Meshes_Current_3B5CE845, StentPlanningViewportIdentifier, DicomViewMode_get_isCenterline, ActiveSegmentation_get_describe, ActiveSegmentation, ActiveSegmentation_get_all, DicomViewMode_get_isMprView, ImageData_VisceralMasks__43A3F7B7, DicomViewMode_get_names, DicomViewMode, DisplayMap_describe } from "../Common/CommonTypes.js";
import { StentPlanningViewMode_get_all, RotationAngle, OutboundMsg, ViewportSelector, StentEditMode, StentPlanningViewMode, ModelStentPlanning__get_hasUnsavedChanges, StentPlanningViewMode_get_describe, LocalMsg } from "./StentPlanningTypes.js";
import * as react from "react";
import { keyValueList } from "../../fable_modules/fable-library-js.4.19.3/MapUtil.js";
import { DOMAttr, HTMLAttr, CSSProp } from "../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { toArray as toArray_2, ofArray, sortBy, empty, filter, map as map_1, maxBy, isEmpty, cons, singleton } from "../../fable_modules/fable-library-js.4.19.3/List.js";
import { curry2, round, defaultOf, int32ToString, equals, comparePrimitives } from "../../fable_modules/fable-library-js.4.19.3/Util.js";
import { RevisionViewModel_revisionNameByNumber_Z524259A4 } from "../../RAWMap.Models/View/Revision.js";
import { body, Label_Option, label as label_3, Option, div } from "../../fable_modules/Fulma.3.0.0/Elements/Form/Field.fs.js";
import { Common_StudyStatus, Visualization_UnifiedTransitionBranch_get_toDistance, Visualization_UnifiedBranch_get_all, Visualization_UnifiedBranch, Visualization_UnifiedDistanceBranch, Visualization_UnifiedBranch_get_describe } from "../../RAWMap.Models/Common.js";
import { Shared_defaultButtonStyles, Shared_onButtonStyles } from "../VisualizationShared.js";
import { Option as Option_1, button } from "../../fable_modules/Fulma.3.0.0/Elements/Button.fs.js";
import { toArray as toArray_1, iterate, empty as empty_1, singleton as singleton_1, append, delay, toList } from "../../fable_modules/fable-library-js.4.19.3/Seq.js";
import { CprVisualizationProps, CprViewMode, DicomVisualizationProps, AnglePropsModel, LengthPropsModel, SegmentationColor, SlicingMode, StentPlanningProps, stentPlanningEventNames, VisualizationProps, MeshVisualizationProps, InteractionModeProps, InteractionView, AngleMeasurementState, LengthMeasurementState, RotationAngles, eventNames, cprEventNames, CustomScreenshotEventArgs, dicomEventNames, SegmentationPaintingMode, CprControlPointModeModule_invert } from "../VisualizationBindings.js";
import { Helpers_nothing } from "../../fable_modules/Fable.React.9.4.0/Fable.React.Helpers.fs.js";
import { Modifier_IModifier, Screen, Common_GenericOption, Size_ISize, Color_IColor } from "../../fable_modules/Fulma.3.0.0/Common.fs.js";
import { Fa_i, Fa_IconOption } from "../../fable_modules/Fable.FontAwesome.3.0.0/FontAwesome.fs.js";
import { tryFind, toArray as toArray_3, values, FSharpMap__get_Item } from "../../fable_modules/fable-library-js.4.19.3/Map.js";
import { showSlicePlaneTool } from "../SlicePlane/SlicePlaneView.js";
import { Controls_spinner, Controls_ExpandableText_render, InputElement_ref, Forms_formFieldReactSelect } from "../../Common/General.js";
import { Option as Option_4, div as div_1 } from "../../fable_modules/Fulma.3.0.0/Elements/Form/Control.fs.js";
import { input } from "../../fable_modules/Fulma.3.0.0/Elements/Form/Input.fs.js";
import { Option as Option_2, IInputType } from "../../fable_modules/Fulma.3.0.0/Elements/Form/Input.fs.js";
import { op_UnaryNegation_Int32, tryParse } from "../../fable_modules/fable-library-js.4.19.3/Int32.js";
import { Record, FSharpRef, toString } from "../../fable_modules/fable-library-js.4.19.3/Types.js";
import { Option_ofBoolAndValue } from "../../Common/Extensions.js";
import { interpolate, printf, toText } from "../../fable_modules/fable-library-js.4.19.3/String.js";
import { Option as Option_5, icon as icon_10 } from "../../fable_modules/Fulma.3.0.0/Elements/Icon.fs.js";
import { Item_Option, Item_button, content as content_1, menu, trigger, Option as Option_3, dropdown } from "../../fable_modules/Fulma.3.0.0/Components/Dropdown.fs.js";
import { dispatchCustomEvent } from "./StentPlanningState.js";
import { max, min, tryParse as tryParse_1 } from "../../fable_modules/fable-library-js.4.19.3/Double.js";
import { wrapInboundMsg, wrapLocalMsg, wrapOutboundMsg } from "../../Common/InboundOutbound.js";
import { Level_Option, level } from "../../fable_modules/Fulma.3.0.0/Layouts/Level.fs.js";
import { Tooltip_tooltip } from "../../Common/Controls.js";
import { content as content_2, Header_title, header as header_1, card } from "../../fable_modules/Fulma.3.0.0/Components/Card.fs.js";
import { Option as Option_6, content as content_3 } from "../../fable_modules/Fulma.3.0.0/Elements/Content.fs.js";
import { SliderIndex, mkVerticalPlaneSlider } from "../CenterlineMeasurement/CenterlineMeasurmentComponents.js";
import { ModelSlicePlane_Props_Z714BB56C, InboundMsg } from "../SlicePlane/SlicePlaneTypes.js";
import { ModelCenterlineMeasurement_Props_1DD22ABF, InboundMsg as InboundMsg_1 } from "../CenterlineMeasurement/StentPlanning/CenterlineMeasurementTypes.js";
import { Split_View_makeHorizontalField } from "../MeasurementsView.js";
import { record_type, class_type } from "../../fable_modules/fable-library-js.4.19.3/Reflection.js";
import { SimplifiedStentMeasurements_fromStentMeasurements_2650BC81, StentMeasurement__get_centerlineMeasurement, StentMeasurement_getBounds } from "../CenterlineMeasurement/StentPlanning/SharedTypes.js";
import { Bindings_PlaneIdentifier } from "../../RAWMap.Models/View/CenterlineMeasurement.js";
import { op_Subtraction, utcNow, now as now_1 } from "../../fable_modules/fable-library-js.4.19.3/Date.js";
import { DeviceOptionViewModel, DeviceOptionsViewModel, DeviceOptionViewModel_get_empty } from "../../RAWMap.Models/View/DeviceOptions.js";
import { box$0027 } from "../../fable_modules/Fulma.3.0.0/Elements/Box.fs.js";
import { h4 } from "../../fable_modules/Fulma.3.0.0/Elements/Heading.fs.js";
import { label as label_4 } from "../../fable_modules/Fulma.3.0.0/Elements/Form/Label.fs.js";
import { Card_foot, Card_body, Card_title, Card_head, Card_card, background, Option as Option_7, modal } from "../../fable_modules/Fulma.3.0.0/Components/Modal.fs.js";
import { InteractionMode, CommonInteractionMode } from "../Common/CommonBindings.js";
import { singleton as singleton_2 } from "../../fable_modules/fable-library-js.4.19.3/Array.js";
import { ArrayNames_fieldDataArrayNames } from "../CenterlineMeasurement/CenterlineMeasurementCoreTypes.js";
import { StentPlanningCenterlinesProps } from "../StentPlanningCenterlines/StentPlanningCenterlinesBindings.js";
import { NotesProps } from "../Notes/NotesBindings.js";
import { ModelCamera_Props } from "../Camera/CameraTypes.js";
import { CalipersProps } from "../Calipers/CalipersBindings.js";
import { ScreenshotProps } from "../Screenshot/ScreenshotBindings.js";
import { ModelPickedMapValue_Props } from "../PickedMapValue/PickedMapValueTypes.js";
import { ModelAnatomyOrientation_Props_Z550008EC } from "../AnatomyOrientation/AnatomyOrientationTypes.js";
import MeshVisualization from "../../../../src/RAWMap.Client/Visualization/js/MeshVisualization.js";
import OrthogonalCprVisualization from "../../../../src/RAWMap.Client/Visualization/js/OrthogonalCprVisualization.js";
import DicomVisualization from "../../../../src/RAWMap.Client/Visualization/js/DicomVisualization.js";
import CprVisualization from "../../../../src/RAWMap.Client/Visualization/js/CprVisualization.js";
import { Functions_flip } from "../../fable_modules/Webbler.Models.1.6.0/Common.fs.js";
import { screenshotModal } from "../Screenshot/ScreenshotView.js";

export function canUserViewCustomStentReport(maybeCurrentUser) {
    return defaultArg(map((user) => isAllowed(new Permission(34, []))(user.roles), maybeCurrentUser), false);
}

function mkMapSelect(dispatch, viewPort, viewMode, maps, selectedMap) {
    const dispatchLocal = mkDispatchLocal(dispatch);
    const props = [["style", {
        minWidth: "150px",
    }]];
    const children = [FormField_reactSelectSingle(maps, [], [new SelectPropsMulti$1(10, [false]), new SelectPropsMulti$1(11, ["auto"]), new SelectPropsMulti$1(12, ["fixed"])], DisplayMap_describe, selectedMap, new FormField_ReactSelectCallback$1((maybeNewValue) => {
        if (maybeNewValue == null) {
        }
        else {
            dispatchLocal(new LocalMsg(1, [viewPort, maybeNewValue]));
        }
    }), "", [])];
    return react.createElement("div", keyValueList(props, 1), ...children);
}

function mkDicomSelectStyles(isMeasurementSelected) {
    const baseStyles = singleton(new CSSProp(253, ["150px"]));
    if (isMeasurementSelected) {
        return cons(new CSSProp(224, ["15px"]), baseStyles);
    }
    else {
        return baseStyles;
    }
}

function mkDicomSelect(dispatch, isMeasurementSelected, dicomViews, selectedView) {
    const dispatchLocal = mkDispatchLocal(dispatch);
    const props = [["style", keyValueList(mkDicomSelectStyles(isMeasurementSelected), 1)]];
    const children = [FormField_reactSelectSingle(dicomViews, [], [new SelectPropsMulti$1(10, [false]), new SelectPropsMulti$1(11, ["auto"]), new SelectPropsMulti$1(12, ["fixed"]), new SelectPropsMulti$1(9, [isMeasurementSelected])], (_arg) => {
        switch (_arg.tag) {
            case 0:
                return "Axial";
            case 5:
                return "Centerline";
            default:
                return "";
        }
    }, selectedView, new FormField_ReactSelectCallback$1((maybeNewView) => {
        if (maybeNewView == null) {
        }
        else {
            dispatchLocal(new LocalMsg(26, [maybeNewView, undefined]));
        }
    }), "", [])];
    return react.createElement("div", keyValueList(props, 1), ...children);
}

function mkRevisionSelect(dispatch, isDisabled, revisions, selectedRevision, currentUiDataFileChecksum) {
    const dispatchLocal = mkDispatchLocal(dispatch);
    let disabledOptions;
    const matchValue = flatten(map((r) => r.uiDataFileChecksum, isEmpty(revisions) ? undefined : maxBy((rev) => rev.revisionNumber, revisions, {
        Compare: comparePrimitives,
    })));
    disabledOptions = ((matchValue != null) ? map_1((Value_1) => Value_1, filter((r_1) => !equals(r_1.uiDataFileChecksum, currentUiDataFileChecksum), revisions)) : empty());
    const props = [["style", {
        minWidth: "150px",
    }]];
    const children = [FormField_reactSelectSingle(cons(undefined, map_1((Value_2) => Value_2, sortBy((r_2) => r_2.revisionNumber, revisions, {
        Compare: comparePrimitives,
    }))), disabledOptions, [new SelectPropsMulti$1(10, [false]), new SelectPropsMulti$1(11, ["auto"]), new SelectPropsMulti$1(12, ["fixed"]), new SelectPropsMulti$1(9, [isDisabled])], (arg_3) => RevisionViewModel_revisionNameByNumber_Z524259A4(defaultArg(map((r_3) => r_3.revisionNumber, arg_3), 0)), some(selectedRevision), new FormField_ReactSelectCallback$1((arg_1) => {
        dispatchLocal(new LocalMsg(59, [flatten(arg_1)]));
    }), "", [])];
    return react.createElement("div", keyValueList(props, 1), ...children);
}

function mkCprBranchSelect(dispatch, isDisabled, dicomViews, selectedBranch) {
    let props_2, children_2;
    const dispatchLocal = mkDispatchLocal(dispatch);
    const children_4 = [div(ofArray([new Option(10, ["horizontal-field"]), new Option(8, []), new Option(11, [singleton(["style", {
        alignItems: "center",
        width: "100%",
    }])])]), singleton(label_3(singleton(new Label_Option(1, [])), singleton(react.createElement("label", {}, "Branch"))))), (props_2 = [["style", {
        minWidth: "6.5em",
        marginRight: "1em",
    }]], (children_2 = [FormField_reactSelectSingle(dicomViews, [], [new SelectPropsMulti$1(10, [false]), new SelectPropsMulti$1(11, ["auto"]), new SelectPropsMulti$1(12, ["fixed"]), new SelectPropsMulti$1(9, [isDisabled])], Visualization_UnifiedBranch_get_describe(), selectedBranch, new FormField_ReactSelectCallback$1((maybeNewBranch) => {
        if (maybeNewBranch == null) {
        }
        else {
            dispatchLocal(new LocalMsg(27, [maybeNewBranch, undefined, undefined, false]));
        }
    }), "", [])], react.createElement("div", keyValueList(props_2, 1), ...children_2)))];
    return react.createElement(react.Fragment, {}, ...children_4);
}

function mkCprControlPointEditModeButton(dispatch, isDisabled, mode) {
    const dispatchLocal = mkDispatchLocal(dispatch);
    const buttonStyle = (mode.tag === 1) ? Shared_onButtonStyles : Shared_defaultButtonStyles;
    return button(toList(delay(() => append(singleton_1(new Option_1(16, [isDisabled])), delay(() => append(singleton_1(new Option_1(17, [ofArray([new HTMLAttr(158, ["Add or Remove Control Point Toggle"]), new DOMAttr(40, [(_arg) => {
        dispatchLocal(new LocalMsg(80, [CprControlPointModeModule_invert(mode)]));
    }]), new HTMLAttr(159, ["button"])])])), delay(() => buttonStyle)))))), singleton("Add/Remove Control Point"));
}

function mkCenterlineDicomBranchSelect(dispatch, isMeasurementSelected, branches, selectedBranch) {
    const dispatchLocal = mkDispatchLocal(dispatch);
    const props = [["style", keyValueList(mkDicomSelectStyles(isMeasurementSelected), 1)]];
    const children = [FormField_reactSelectSingle(branches, [], [new SelectPropsMulti$1(10, [false]), new SelectPropsMulti$1(11, ["auto"]), new SelectPropsMulti$1(12, ["fixed"]), new SelectPropsMulti$1(9, [isMeasurementSelected])], Visualization_UnifiedBranch_get_describe(), selectedBranch, new FormField_ReactSelectCallback$1((maybeNewValue) => {
        if (maybeNewValue == null) {
        }
        else {
            const newBranch = maybeNewValue;
            dispatchLocal(new LocalMsg(26, [new DicomViewMode(5, [newBranch]), undefined]));
            dispatchLocal(new LocalMsg(27, [newBranch, undefined, undefined, false]));
        }
    }), "", [])];
    return react.createElement("div", keyValueList(props, 1), ...children);
}

function mkViewModeSelect(dispatch, isDisabled, viewModes, disabledViewModes, selectedView) {
    const dispatchLocal = mkDispatchLocal(dispatch);
    const children = [FormField_reactSelectSingle(viewModes, disabledViewModes, [new SelectPropsMulti$1(10, [false]), new SelectPropsMulti$1(11, ["auto"]), new SelectPropsMulti$1(12, ["fixed"]), new SelectPropsMulti$1(9, [isDisabled])], StentPlanningViewMode_get_describe(), selectedView, new FormField_ReactSelectCallback$1((maybeNewView) => {
        if (maybeNewView == null) {
        }
        else {
            dispatchLocal(new LocalMsg(10, [maybeNewView]));
        }
    }), "", [])];
    return react.createElement("div", {
        className: "view-mode-select",
    }, ...children);
}

function mkMeasurementButtons(dispatch, model) {
    const dispatchLocal = mkDispatchLocal(dispatch);
    const matchValue = model.MaybeActiveMeasurement;
    if (matchValue == null) {
        return Helpers_nothing;
    }
    else {
        const active = matchValue;
        const props = [["style", {
            position: "absolute",
            top: "93%",
            width: "100%",
            display: "flex",
        }]];
        const children = [button(ofArray([new Option_1(0, [new Color_IColor(5, [])]), new Option_1(16, [!ModelStentPlanning__get_hasUnsavedChanges(model)]), new Option_1(17, [ofArray([new DOMAttr(40, [(_arg) => {
            dispatchLocal(new LocalMsg(16, [active]));
        }]), ["style", {
            marginLeft: "auto",
        }]])])]), singleton("Confirm")), button(ofArray([new Option_1(0, [new Color_IColor(8, [])]), new Option_1(16, [false]), new Option_1(17, [ofArray([new DOMAttr(40, [(_arg_1) => {
            dispatchLocal(new LocalMsg(17, []));
        }]), ["style", {
            marginLeft: "10px",
            marginRight: "10px",
        }]])])]), singleton("Cancel"))];
        return react.createElement("div", keyValueList(props, 1), ...children);
    }
}

function mkCenterlineButtons(dispatch, model) {
    const dispatchLocal = mkDispatchLocal(dispatch);
    if (model.IsEditingCprPoints) {
        const children = [button(ofArray([new Option_1(0, [new Color_IColor(5, [])]), new Option_1(16, [false]), new Option_1(17, [singleton(new DOMAttr(40, [(_arg) => {
            dispatchLocal(new LocalMsg(78, []));
        }]))])]), singleton("Confirm")), button(ofArray([new Option_1(0, [new Color_IColor(8, [])]), new Option_1(16, [false]), new Option_1(17, [singleton(new DOMAttr(40, [(_arg_1) => {
            dispatchLocal(new LocalMsg(79, []));
        }]))])]), singleton("Cancel"))];
        return react.createElement("div", {
            className: "cpr-centerline-edit-buttons",
        }, ...children);
    }
    else {
        return Helpers_nothing;
    }
}

function mkViewportToolPanel(children) {
    const props = [["style", {
        position: "absolute",
        top: "8px",
        left: "8px",
        zIndex: "2",
    }]];
    return react.createElement("div", keyValueList(props, 1), ...children);
}

function mkMainToolPanel(imageData, model, dispatch) {
    let tupledArg, tupledArg_1, tupledArg_2, matchValue_25, patientViewModel, arrangeContent, arg_22, arg_25, props_64, children_64;
    const dispatchLocal = mkDispatchLocal(dispatch);
    let stentPlanningTool;
    const classes = `${"button--popout"} ${"button--popout"}--${model.IsStentPlanningVisible ? (!equals(model.ViewMode, new StentPlanningViewMode(0, [])) ? "on" : "off") : "off"}`;
    const buttonStyles = model.IsStentPlanningVisible ? (!equals(model.ViewMode, new StentPlanningViewMode(0, [])) ? Shared_onButtonStyles : Shared_defaultButtonStyles) : Shared_defaultButtonStyles;
    stentPlanningTool = mkToolReactButton(dispatch, toList(delay(() => append(buttonStyles, delay(() => append(singleton_1(new Option_1(17, [singleton(new HTMLAttr(99, ["stent-plan-toggle"]))])), delay(() => singleton_1(new Option_1(19, [classes])))))))), new Fa_IconOption(11, ["fas fa-map"]), new LocalMsg(53, [!model.IsStentPlanningVisible]), false, (model.IsSelectingViewport != null) ? true : equals(model.ViewMode, new StentPlanningViewMode(0, [])), model.IsStentPlanningVisible ? "Hide Stent Planning" : "Show Stent Planning");
    let centerlineTool;
    const isOn = model.DisplayCenterline;
    centerlineTool = mkToolReactButton(dispatch, isOn ? Shared_onButtonStyles : Shared_defaultButtonStyles, new Fa_IconOption(11, ["fas fa-grip-lines-vertical"]), new LocalMsg(4, [!isOn]), false, false, ((_arg) => {
        if (_arg) {
            return "Hide centerline of flow";
        }
        else {
            return "Show centerline of flow";
        }
    })(isOn));
    let slicePlaneTool;
    const patternInput = (model.SelectedDicomView.tag === 5) ? [FSharpMap__get_Item(model.SlicePlaneModels, DicomViewMode_get_names().CenterlinePlaneA), (msg) => {
        dispatchLocal(new LocalMsg(7, [new DicomViewMode(5, [new Visualization_UnifiedBranch(0, [new Visualization_UnifiedDistanceBranch(2, [])])]), msg]));
        dispatchLocal(new LocalMsg(7, [new DicomViewMode(6, [new Visualization_UnifiedBranch(0, [new Visualization_UnifiedDistanceBranch(2, [])])]), msg]));
    }] : [FSharpMap__get_Item(model.SlicePlaneModels, DicomViewMode_get_names().Axial), (msg_1) => {
        dispatchLocal(new LocalMsg(7, [new DicomViewMode(0, []), msg_1]));
    }];
    slicePlaneTool = showSlicePlaneTool(false, patternInput[0], patternInput[1]);
    const crosshairTool = mkToolReactButton(dispatch, model.IsCrosshairEnabled ? Shared_onButtonStyles : Shared_defaultButtonStyles, new Fa_IconOption(11, ["fas fa-crosshairs"]), new LocalMsg(71, [!model.IsCrosshairEnabled]), false, !(model.ViewMode.tag === 2), model.IsCrosshairEnabled ? "Disable Crosshair" : "Enable Crosshair");
    let zoomScrollToggle;
    const patternInput_1 = model.IsSliceScroll ? ["Switch mouse wheel action to Zoom", new Fa_IconOption(15, ["fas fa-magnifying-glass"]), false] : ["Switch mouse wheel action to Scroll CT Slices", new Fa_IconOption(15, ["fas fa-arrow-down-up-across-line"]), false];
    zoomScrollToggle = mkToolReactButton(dispatch, Shared_defaultButtonStyles, patternInput_1[1], new LocalMsg(3, [!model.IsSliceScroll]), false, patternInput_1[2], patternInput_1[0]);
    const windowLevelButton = mkToolReactButton(dispatch, !model.ShowMasks ? Shared_onButtonStyles : Shared_defaultButtonStyles, new Fa_IconOption(15, ["fas fa-circle-half-stroke"]), new LocalMsg(30, [!model.ShowMasks]), false, false, "Adjust Window/Level");
    let segmentationSelect;
    const visible = (model.ViewMode.tag === 1) ? "hidden" : "visible";
    let activeSegmentation;
    const matchValue_16 = model.CenterlineMeasurementModel.MaybeSelectedPlaneIdentifier;
    let matchResult;
    if (matchValue_16 != null) {
        if (matchValue_16.tag === 1) {
            matchResult = 0;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            activeSegmentation = model.BottomPlaneActiveSegmentation;
            break;
        }
        default:
            activeSegmentation = model.ActiveSegmentation;
    }
    const visceralFiles = (imageData == null) ? [] : ImageData_VisceralMasks__43A3F7B7(imageData);
    const props = [["style", {
        visibility: visible,
        marginTop: "0",
        marginBottom: "0",
    }]];
    const children = [Forms_formFieldReactSelect([new SelectPropsMulti$1(10, [false]), new SelectPropsMulti$1(9, [!DicomViewMode_get_isMprView()(model.SelectedDicomView)]), new SelectPropsMulti$1(11, ["auto"]), new SelectPropsMulti$1(12, ["fixed"])], "", activeSegmentation, ActiveSegmentation_get_all(), toList(delay(() => ((visceralFiles.length === 0) ? singleton_1(new ActiveSegmentation(2, [])) : empty_1()))), ActiveSegmentation_get_describe(), (arg) => {
        dispatchLocal(new LocalMsg(50, [arg]));
    })];
    segmentationSelect = react.createElement("div", keyValueList(props, 1), ...children);
    let bumpToolToggle;
    const currentlyInBumpMode = equals(model.SegmentationProps.paintingMode, new SegmentationPaintingMode(0, []));
    let patternInput_3;
    const matchValue_17 = model.SegmentationProps.paintingEnabled;
    let matchResult_1;
    if (!DicomViewMode_get_isCenterline()(model.SelectedDicomView) && !DicomViewMode_get_isMprView()(model.SelectedDicomView)) {
        matchResult_1 = 0;
    }
    else if (model.MaybeActiveMeasurement == null) {
        if (DicomViewMode_get_isCenterline()(model.SelectedDicomView) ? true : equals(model.ViewMode, new StentPlanningViewMode(1, []))) {
            matchResult_1 = 1;
        }
        else if (matchValue_17) {
            if (currentlyInBumpMode) {
                matchResult_1 = 2;
            }
            else {
                matchResult_1 = 3;
            }
        }
        else {
            matchResult_1 = 3;
        }
    }
    else if (matchValue_17) {
        if (currentlyInBumpMode) {
            matchResult_1 = 2;
        }
        else {
            matchResult_1 = 3;
        }
    }
    else {
        matchResult_1 = 3;
    }
    switch (matchResult_1) {
        case 0: {
            patternInput_3 = ["Segmentation bump tool is not available in the current view", new Fa_IconOption(15, ["fas fa-plus-minus"]), true];
            break;
        }
        case 1: {
            patternInput_3 = ["Please select a measurement from the Stent Plan view to enable segmentation bump tool", new Fa_IconOption(15, ["fas fa-plus-minus"]), true];
            break;
        }
        case 2: {
            patternInput_3 = ["Disable segmentation bump tool", new Fa_IconOption(15, ["fas fa-plus-minus"]), false];
            break;
        }
        default:
            patternInput_3 = ["Enable segmentation bump tool", new Fa_IconOption(15, ["fas fa-plus-minus"]), false];
    }
    bumpToolToggle = mkToolReactButton(dispatch, (model.SegmentationProps.paintingEnabled && currentlyInBumpMode) ? Shared_onButtonStyles : Shared_defaultButtonStyles, patternInput_3[1], (tupledArg = [!(model.SegmentationProps.paintingEnabled && currentlyInBumpMode), new SegmentationPaintingMode(0, [])], new LocalMsg(31, [tupledArg[0], tupledArg[1]])), false, patternInput_3[2], patternInput_3[0]);
    let paintBrushToggle;
    const currentlyInPaintMode = equals(model.SegmentationProps.paintingMode, new SegmentationPaintingMode(1, []));
    const patternInput_4 = (!DicomViewMode_get_isMprView()(model.SelectedDicomView) ? true : equals(model.ViewMode, new StentPlanningViewMode(1, []))) ? ["Segmentation painter is not available in the current view", new Fa_IconOption(15, ["fas fa-paintbrush"]), true] : (model.SegmentationProps.paintingEnabled ? (currentlyInPaintMode ? ["Disable segmentation painter", new Fa_IconOption(15, ["fas fa-paintbrush"]), false] : ["Enable segmentation painter", new Fa_IconOption(15, ["fas fa-paintbrush"]), false]) : ["Enable segmentation painter", new Fa_IconOption(15, ["fas fa-paintbrush"]), false]);
    paintBrushToggle = mkToolReactButton(dispatch, (model.SegmentationProps.paintingEnabled && currentlyInPaintMode) ? Shared_onButtonStyles : Shared_defaultButtonStyles, patternInput_4[1], (tupledArg_1 = [!(model.SegmentationProps.paintingEnabled && currentlyInPaintMode), new SegmentationPaintingMode(1, [])], new LocalMsg(31, [tupledArg_1[0], tupledArg_1[1]])), false, patternInput_4[2] ? true : equals(model.ViewMode, new StentPlanningViewMode(1, [])), patternInput_4[0]);
    let paintEraseToggle;
    const currentlyInEraseMode = equals(model.SegmentationProps.paintingMode, new SegmentationPaintingMode(2, []));
    const patternInput_5 = (!DicomViewMode_get_isMprView()(model.SelectedDicomView) ? true : equals(model.ViewMode, new StentPlanningViewMode(1, []))) ? ["Segmentation eraser is not available in the current view", new Fa_IconOption(15, ["fas fa-eraser"]), true] : (model.SegmentationProps.paintingEnabled ? (currentlyInEraseMode ? ["Disable segmentation eraser", new Fa_IconOption(15, ["fas fa-eraser"]), false] : ["Enable segmentation eraser", new Fa_IconOption(15, ["fas fa-eraser"]), false]) : ["Enable segmentation eraser", new Fa_IconOption(15, ["fas fa-eraser"]), false]);
    paintEraseToggle = mkToolReactButton(dispatch, (model.SegmentationProps.paintingEnabled && currentlyInEraseMode) ? Shared_onButtonStyles : Shared_defaultButtonStyles, patternInput_5[1], (tupledArg_2 = [!(model.SegmentationProps.paintingEnabled && currentlyInEraseMode), new SegmentationPaintingMode(2, [])], new LocalMsg(31, [tupledArg_2[0], tupledArg_2[1]])), false, patternInput_5[2] ? true : equals(model.ViewMode, new StentPlanningViewMode(1, [])), patternInput_5[0]);
    let huSelectToggle;
    const patternInput_6 = (!equals(model.SelectedDicomView, new DicomViewMode(0, [])) ? true : equals(model.ViewMode, new StentPlanningViewMode(1, []))) ? ["HU select is not available in the current view", new Fa_IconOption(15, ["fas fa-wand-magic-sparkles"]), true] : (model.SegmentationProps.huSelectEnabled ? ["Disable HU select", new Fa_IconOption(15, ["fas fa-wand-magic-sparkles"]), false] : ["Enable HU select (click to fill similar HU)", new Fa_IconOption(15, ["fas fa-wand-magic-sparkles"]), false]);
    huSelectToggle = mkToolReactButton(dispatch, model.SegmentationProps.huSelectEnabled ? Shared_onButtonStyles : Shared_defaultButtonStyles, patternInput_6[1], new LocalMsg(33, [!model.SegmentationProps.huSelectEnabled]), false, patternInput_6[2] ? true : equals(model.ViewMode, new StentPlanningViewMode(1, [])), patternInput_6[0]);
    let huModeSwitch;
    if (model.SegmentationProps.huSelectEnabled) {
        const inEraseMode = model.SegmentationProps.huEraseMode;
        const selectBtn = mkToolReactButton(dispatch, inEraseMode ? Shared_defaultButtonStyles : Shared_onButtonStyles, new Fa_IconOption(15, ["fas fa-plus"]), new LocalMsg(34, [false]), false, false, "Select (add to mask)");
        const eraseBtn = mkToolReactButton(dispatch, inEraseMode ? Shared_onButtonStyles : Shared_defaultButtonStyles, new Fa_IconOption(15, ["fas fa-minus"]), new LocalMsg(34, [true]), false, false, "Erase (remove selection)");
        huModeSwitch = div(ofArray([new Option(8, []), new Option(11, [singleton(["style", {
            alignItems: "center",
            marginLeft: "0.5rem",
        }])])]), ofArray([label_3(ofArray([new Label_Option(1, []), new Label_Option(3, [singleton(["style", {
            marginRight: "0.4rem",
        }])])]), singleton(react.createElement("label", {}, "Mode"))), div_1(empty(), ofArray([selectBtn, eraseBtn]))]));
    }
    else {
        huModeSwitch = Helpers_nothing;
    }
    const huToleranceInput = model.SegmentationProps.huSelectEnabled ? div(ofArray([new Option(8, []), new Option(11, [singleton(["style", {
        alignItems: "center",
        marginLeft: "0.5rem",
    }])])]), ofArray([label_3(ofArray([new Label_Option(1, []), new Label_Option(3, [singleton(["style", {
        marginRight: "0.4rem",
    }])])]), singleton(react.createElement("label", {}, "± HU"))), div_1(empty(), singleton(input(ofArray([new Option_2(1, [new IInputType(7, [])]), new Option_2(8, [int32ToString(model.SegmentationProps.huTolerance)]), new Option_2(13, [(e) => {
        let tupledArg_3, outArg;
        iterate((arg_2) => {
            dispatchLocal(new LocalMsg(35, [arg_2]));
        }, toArray((tupledArg_3 = ((outArg = 0, [tryParse(toString(e.currentTarget.value), 511, false, 32, new FSharpRef(() => outArg, (v) => {
            outArg = (v | 0);
        })), outArg])), Option_ofBoolAndValue(tupledArg_3[0], tupledArg_3[1]))));
    }]), new Option_2(15, [ofArray([new HTMLAttr(119, [1]), new HTMLAttr(114, [2000]), new HTMLAttr(64, ["no-spinner"]), ["style", {
        width: "6ch",
    }]])]), new Option_2(0, [new Size_ISize(0, [])])]))))])) : Helpers_nothing;
    const huMaxRadiusInput = model.SegmentationProps.huSelectEnabled ? div(ofArray([new Option(8, []), new Option(11, [singleton(["style", {
        alignItems: "center",
        marginLeft: "0.5rem",
    }])])]), ofArray([label_3(ofArray([new Label_Option(1, []), new Label_Option(3, [singleton(["style", {
        marginRight: "0.4rem",
    }])])]), singleton(react.createElement("label", {}, "Max radius"))), div_1(empty(), singleton(input(ofArray([new Option_2(1, [new IInputType(7, [])]), new Option_2(8, [int32ToString(model.SegmentationProps.huMaxRadius)]), new Option_2(13, [(e_1) => {
        let tupledArg_4, outArg_1;
        iterate((arg_4) => {
            dispatchLocal(new LocalMsg(36, [arg_4]));
        }, toArray((tupledArg_4 = ((outArg_1 = 0, [tryParse(toString(e_1.currentTarget.value), 511, false, 32, new FSharpRef(() => outArg_1, (v_1) => {
            outArg_1 = (v_1 | 0);
        })), outArg_1])), Option_ofBoolAndValue(tupledArg_4[0], tupledArg_4[1]))));
    }]), new Option_2(15, [ofArray([new HTMLAttr(119, [1]), new HTMLAttr(114, [300]), new HTMLAttr(64, ["no-spinner"]), ["style", {
        width: "6ch",
    }]])]), new Option_2(0, [new Size_ISize(0, [])])]))))])) : Helpers_nothing;
    const makeHorizontalField = (givenLabel, width, contents) => div(ofArray([new Option(10, ["horizontal-field"]), new Option(8, []), new Option(11, [singleton(["style", {
        alignItems: "center",
        width: "100%",
    }])])]), ofArray([label_3(ofArray([new Label_Option(1, []), new Label_Option(3, [singleton(["style", {
        flexBasis: width,
    }])])]), singleton(react.createElement("label", {}, givenLabel))), body(singleton(new Common_GenericOption(1, [singleton(["style", {
        marginLeft: "auto",
        flexGrow: "unset",
    }])])), singleton(contents))]));
    let brushSizeSlider;
    const callback = FormField_onChangeNumberDispatch((maybeNumber) => {
        defaultArg(map((number) => {
            dispatchLocal(new LocalMsg(32, [number]));
        }, maybeNumber), undefined);
    }, model.SegmentationProps.paintingBrushSize);
    brushSizeSlider = makeHorizontalField("Brush Size", "6em", FormField_labeledSlider(1, 50, 1, int32ToString(model.SegmentationProps.paintingBrushSize), [new HTMLAttr(64, ["horizontal-slider"])], [new Option_2(15, [ofArray([new HTMLAttr(158, [`${model.SegmentationProps.paintingBrushSize} px`]), ["style", {
        width: "7em",
    }]])])], callback, "", []));
    let segmentationOpacitySlider;
    if (model.ShowMasks) {
        let opacityValueTooltip;
        const arg_5 = ~~(model.SegmentationProps.segmentationOpacity * 100) | 0;
        opacityValueTooltip = toText(printf("%d%%"))(arg_5);
        const callback_1 = FormField_onChangeNumberDispatch((maybeNumber_1) => {
            defaultArg(map((number_1) => {
                dispatchLocal(new LocalMsg(37, [number_1]));
            }, maybeNumber_1), undefined);
        }, model.SegmentationProps.segmentationOpacity);
        segmentationOpacitySlider = makeHorizontalField("Opacity", "4em", FormField_labeledSlider(0, 1, 0.05, model.SegmentationProps.segmentationOpacity.toString(), [new HTMLAttr(64, ["horizontal-slider"])], [new Option_2(15, [ofArray([new HTMLAttr(158, [opacityValueTooltip]), ["style", {
            width: "7em",
        }]])])], callback_1, "", []));
    }
    else {
        segmentationOpacitySlider = Helpers_nothing;
    }
    let segmentationBorderOpacitySlider;
    if (model.ShowMasks) {
        let opacityValueTooltip_1;
        const arg_6 = ~~(model.SegmentationProps.segmentationBorderOpacity * 100) | 0;
        opacityValueTooltip_1 = toText(printf("%d%%"))(arg_6);
        const callback_2 = FormField_onChangeNumberDispatch((maybeNumber_2) => {
            defaultArg(map((number_2) => {
                dispatchLocal(new LocalMsg(38, [number_2]));
            }, maybeNumber_2), undefined);
        }, model.SegmentationProps.segmentationBorderOpacity);
        segmentationBorderOpacitySlider = makeHorizontalField("Border Opacity", "4em", FormField_slider(0, 1, 0.05, model.SegmentationProps.segmentationBorderOpacity.toString(), [new HTMLAttr(64, ["horizontal-slider"])], [new Option_2(15, [ofArray([new HTMLAttr(158, [opacityValueTooltip_1]), ["style", {
            width: "7em",
        }]])])], callback_2));
    }
    else {
        segmentationBorderOpacitySlider = Helpers_nothing;
    }
    let segmentationBorderThicknessSlider;
    if (model.ShowMasks) {
        const callback_3 = FormField_onChangeNumberDispatch((maybeNumber_3) => {
            defaultArg(map((number_3) => {
                dispatchLocal(new LocalMsg(39, [number_3]));
            }, maybeNumber_3), undefined);
        }, model.SegmentationProps.segmentationBorderThickness);
        segmentationBorderThicknessSlider = makeHorizontalField("Border Thickness", "4em", FormField_slider(0, 10, 1, int32ToString(model.SegmentationProps.segmentationBorderThickness), [new HTMLAttr(64, ["horizontal-slider"])], [new Option_2(15, [ofArray([new HTMLAttr(158, [`${model.SegmentationProps.segmentationBorderThickness}`]), ["style", {
            width: "7em",
        }]])])], callback_3));
    }
    else {
        segmentationBorderThicknessSlider = Helpers_nothing;
    }
    let editModeControl;
    const inCpr = equals(model.ViewMode, new StentPlanningViewMode(1, []));
    const segmentationActive = equals(model.ActiveEditMode, new StentEditMode(0, []));
    const centerlineActive = equals(model.ActiveEditMode, new StentEditMode(1, []));
    const segmentationDisabled = !(((matchValue_25 = model.MaximizedViewport, (matchValue_25 != null) ? (matchValue_25.tag === 2) : true)) && ((model.SelectedDicomView.tag === 5) ? (!(model.MaybeActiveMeasurement == null)) : true));
    const segmentationSettingsDisabled = !segmentationActive ? true : segmentationDisabled;
    const centerlineSettingsDisabled = !centerlineActive;
    const segmentationTooltip = !segmentationDisabled ? "Edit the vessel segmentation" : (inCpr ? "Segmentation is available only after selecting a label from the Stent Plan panel, or by switching to the Standard or MPR view" : "Segmentation is not available for this view");
    const modeButton = (isActive, isDisabled_9, iconClass, label, tooltip, msg_9) => {
        let props_10;
        return button(ofArray([new Option_1(19, [isActive ? "edit-mode-segment is-active" : "edit-mode-segment"]), new Option_1(16, [isDisabled_9]), new Option_1(17, [ofArray([new HTMLAttr(158, [tooltip]), new HTMLAttr(159, ["button"])])]), new Option_1(18, [(_arg_1) => {
            dispatchLocal(msg_9);
        }])]), ofArray([icon_10(empty(), singleton(Fa_i(singleton(new Fa_IconOption(15, [iconClass])), []))), (props_10 = [["style", {
            marginLeft: "0.4rem",
        }]], react.createElement("span", keyValueList(props_10, 1), label))]));
    };
    const panelCaret = (editMode, isActive_1, isDisabled_10, isRight, tooltip_1, content) => dropdown(toList(delay(() => append(singleton_1(new Option_3(0, [equals(model.MaybeOpenEditPanel, editMode) && !isDisabled_10])), delay(() => (isRight ? singleton_1(new Option_3(2, [])) : empty_1()))))), ofArray([trigger(empty(), singleton(button(ofArray([new Option_1(19, [isActive_1 ? "edit-mode-caret is-active" : "edit-mode-caret"]), new Option_1(16, [isDisabled_10]), new Option_1(17, [ofArray([new HTMLAttr(158, [tooltip_1]), new DOMAttr(52, [(_arg_2) => {
        if (!isDisabled_10) {
            dispatchLocal(new LocalMsg(12, [editMode]));
        }
    }])])])]), singleton(icon_10(empty(), singleton(Fa_i(singleton(new Fa_IconOption(11, ["fas fa-angle-down"])), []))))))), menu(empty(), singleton(content_1(empty(), content)))]));
    const segmentationPanel = toList(delay(() => {
        let props_12;
        return append(singleton_1((props_12 = [["style", {
            display: "flex",
            justifyContent: "space-between",
        }]], react.createElement("div", keyValueList(props_12, 1), segmentationSelect, bumpToolToggle, paintBrushToggle, paintEraseToggle, huSelectToggle))), delay(() => append(singleton_1(huModeSwitch), delay(() => {
            let props_14;
            return append(model.SegmentationProps.huSelectEnabled ? singleton_1((props_14 = [["style", {
                display: "flex",
                alignItems: "center",
                columnGap: "1rem",
            }]], react.createElement("div", keyValueList(props_14, 1), huToleranceInput, huMaxRadiusInput))) : singleton_1(brushSizeSlider), delay(() => append(singleton_1(segmentationOpacitySlider), delay(() => append(singleton_1(segmentationBorderOpacitySlider), delay(() => singleton_1(segmentationBorderThicknessSlider)))))));
        }))));
    }));
    const centerlinePanel = ofArray([mkCprBranchSelect(dispatch, model.MaybeActiveMeasurement != null, Visualization_UnifiedBranch_get_all()(model.SelectedCprBranch), model.SelectedCprBranch), mkCprControlPointEditModeButton(dispatch, !centerlineActive, model.CprControlPointMode)]);
    const children_16 = [panelCaret(new StentEditMode(0, []), segmentationActive, segmentationSettingsDisabled, false, "Segmentation settings", segmentationPanel), modeButton(segmentationActive, segmentationDisabled, "fas fa-draw-polygon", "Segmentation", segmentationTooltip, new LocalMsg(11, [new StentEditMode(0, [])])), modeButton(centerlineActive, false, "fas fa-bezier-curve", "Centerline", inCpr ? "Edit the centerline" : "Switch to the CPR view to edit the centerline", new LocalMsg(11, [new StentEditMode(1, [])])), panelCaret(new StentEditMode(1, []), centerlineActive, centerlineSettingsDisabled, true, "Centerline settings", centerlinePanel)];
    editModeControl = react.createElement("div", {
        className: "edit-mode-control",
        onMouseLeave: (_arg_3) => {
            dispatchLocal(new LocalMsg(12, [undefined]));
        },
    }, ...children_16);
    let maximizeViewportButton;
    const patternInput_7 = (model.MaximizedViewport != null) ? ["Clear maximized viewport", new Fa_IconOption(15, ["fas fa-minimize"])] : ["Select Viewport to Maximize", new Fa_IconOption(15, ["fas fa-maximize"])];
    maximizeViewportButton = mkToolReactButton(dispatch, (equals(model.IsSelectingViewport, new ViewportSelector(0, [])) ? true : (model.MaximizedViewport != null)) ? Shared_onButtonStyles : Shared_defaultButtonStyles, patternInput_7[1], ((model.MaximizedViewport != null) ? true : equals(model.IsSelectingViewport, new ViewportSelector(0, []))) ? (new LocalMsg(20, [undefined])) : (new LocalMsg(105, [new ViewportSelector(0, []), (arg_7) => {
        dispatchLocal(new LocalMsg(20, [arg_7]));
    }])), false, false, patternInput_7[0]);
    const customScreenshotButton = mkToolReactButton(dispatch, equals(model.IsSelectingViewport, new ViewportSelector(1, [])) ? Shared_onButtonStyles : Shared_defaultButtonStyles, new Fa_IconOption(15, ["fas fa-camera"]), equals(model.IsSelectingViewport, new ViewportSelector(1, [])) ? (new LocalMsg(106, [undefined])) : (new LocalMsg(105, [new ViewportSelector(1, []), (maybeViewport) => {
        let matchValue_29;
        dispatchLocal(new LocalMsg(109, []));
        let matchResult_2, viewport, viewport_1, viewport_2, viewport_3, viewport_4;
        if (maybeViewport == null) {
            matchResult_2 = 5;
        }
        else {
            switch (maybeViewport.tag) {
                case 2: {
                    matchResult_2 = 0;
                    viewport = maybeViewport;
                    break;
                }
                case 8: {
                    matchResult_2 = 1;
                    viewport_1 = maybeViewport;
                    break;
                }
                case 9: {
                    matchResult_2 = 1;
                    viewport_1 = maybeViewport;
                    break;
                }
                case 4: {
                    matchResult_2 = 1;
                    viewport_1 = maybeViewport;
                    break;
                }
                case 5: {
                    matchResult_2 = 1;
                    viewport_1 = maybeViewport;
                    break;
                }
                case 7: {
                    matchResult_2 = 2;
                    viewport_2 = maybeViewport;
                    break;
                }
                case 6: {
                    matchResult_2 = 3;
                    viewport_3 = maybeViewport;
                    break;
                }
                case 0: {
                    matchResult_2 = 4;
                    viewport_4 = maybeViewport;
                    break;
                }
                case 1: {
                    matchResult_2 = 4;
                    viewport_4 = maybeViewport;
                    break;
                }
                default: {
                    matchResult_2 = 0;
                    viewport = maybeViewport;
                }
            }
        }
        switch (matchResult_2) {
            case 0: {
                dispatchCustomEvent(dicomEventNames.CaptureCustomScreenshot, new CustomScreenshotEventArgs((arg_8) => {
                    dispatchLocal(new LocalMsg(107, [arg_8]));
                }, (matchValue_29 = model.SelectedDicomView, (matchValue_29.tag === 0) ? toString(new StentPlanningViewportIdentifier(3, [])) : ((matchValue_29.tag === 5) ? toString(new StentPlanningViewportIdentifier(8, [])) : toString(viewport)))));
                break;
            }
            case 1: {
                dispatchCustomEvent(dicomEventNames.CaptureCustomScreenshot, new CustomScreenshotEventArgs((arg_9) => {
                    dispatchLocal(new LocalMsg(107, [arg_9]));
                }, toString(viewport_1)));
                break;
            }
            case 2: {
                dispatchCustomEvent(cprEventNames.CaptureCustomScreenshot, new CustomScreenshotEventArgs((arg_10) => {
                    dispatchLocal(new LocalMsg(107, [arg_10]));
                }, `${toString(viewport_2)}_${Visualization_UnifiedBranch_get_describe()(model.SelectedCprBranch)}`));
                break;
            }
            case 3: {
                dispatchCustomEvent(cprEventNames.CaptureCustomScreenshot, new CustomScreenshotEventArgs((arg_11) => {
                    dispatchLocal(new LocalMsg(107, [arg_11]));
                }, toString(viewport_3)));
                break;
            }
            case 4: {
                dispatchCustomEvent(eventNames.CaptureCustomScreenshot, new CustomScreenshotEventArgs((arg_12) => {
                    dispatchLocal(new LocalMsg(107, [arg_12]));
                }, toString(viewport_4)));
                break;
            }
            case 5: {
                dispatchLocal(new LocalMsg(106, [maybeViewport]));
                break;
            }
        }
    }])), false, false, "Take Screenshot");
    const mkStepperComponent = (angleValue, angleLabel) => {
        const props_18 = [["style", {
            textAlign: "center",
            marginTop: "auto",
        }]];
        const children_18 = [toText(interpolate("%0.0f%P()° %P()", [angleValue, angleLabel]))];
        return react.createElement("div", keyValueList(props_18, 1), ...children_18);
    };
    const mkIncrementer = (onChange, updateIncrement, increment) => div(ofArray([new Option(5, []), new Option(0, [])]), ofArray([div_1(singleton(new Option_4(5, [singleton(["style", {
        marginRight: "0px",
    }])])), singleton(button(ofArray([new Option_1(18, [(_arg_4) => {
        onChange((x) => ((y) => (x - y)));
    }]), new Option_1(0, [new Color_IColor(4, [])]), new Option_1(1, [new Size_ISize(0, [])])]), singleton(Fa_i(singleton(new Fa_IconOption(11, ["fas fa-minus"])), []))))), input(ofArray([new Option_2(1, [new IInputType(7, [])]), new Option_2(14, [(e_2) => {
        InputElement_ref(increment, e_2);
    }]), new Option_2(15, [ofArray([new HTMLAttr(114, [360]), new HTMLAttr(119, [0])])]), new Option_2(13, [(e_3) => {
        let tupledArg_5, outArg_2;
        iterate(updateIncrement, toArray((tupledArg_5 = ((outArg_2 = 0, [tryParse_1(toString(e_3.currentTarget.value), new FSharpRef(() => outArg_2, (v_2) => {
            outArg_2 = v_2;
        })), outArg_2])), Option_ofBoolAndValue(tupledArg_5[0], tupledArg_5[1]))));
    }]), new Option_2(15, [ofArray([new HTMLAttr(64, ["no-spinner"]), ["style", {
        width: "6ch",
    }]])]), new Option_2(0, [new Size_ISize(0, [])])])), div_1(empty(), singleton(button(ofArray([new Option_1(18, [(_arg_5) => {
        onChange((x_1) => ((y_1) => (x_1 + y_1)));
    }]), new Option_1(0, [new Color_IColor(4, [])]), new Option_1(1, [new Size_ISize(0, [])])]), singleton(Fa_i(singleton(new Fa_IconOption(11, ["fas fa-plus"])), [])))))]));
    const mkResetCameraButton = mkToolReactButton(dispatch, [new Option_1(0, [new Color_IColor(4, [])]), new Option_1(1, [new Size_ISize(0, [])])], new Fa_IconOption(15, ["fas fa-camera-rotate"]), new LocalMsg(22, []), false, false, "Reset Camera");
    const mkSnapTopAngleButton = (icon_8, onChange_1) => button(ofArray([new Option_1(17, [singleton(["style", {
        marginRight: "5px",
    }])]), new Option_1(18, [onChange_1]), new Option_1(0, [new Color_IColor(4, [])]), new Option_1(1, [new Size_ISize(0, [])])]), singleton(icon_10(singleton(new Option_5(4, [singleton(["style", {}])])), singleton(Fa_i(singleton(icon_8), [])))));
    const mkAngleDisplayTool = (rotationAngle, angle) => {
        if (rotationAngle.tag === 1) {
            const increment_2 = model.RotationIncrement.elevation;
            const patternInput_9 = (angle >= 0) ? [angle, "CRA"] : ((angle < 0) ? [Math.abs(angle), "CAU"] : [Number.NaN, "?"]);
            return [mkStepperComponent(patternInput_9[0], patternInput_9[1]), mkIncrementer((adjustAngle_1) => {
                dispatchLocal(new LocalMsg(24, [new RotationAngles(0, adjustAngle_1(0)(-increment_2))]));
            }, (n_1) => {
                dispatchLocal(new LocalMsg(25, [new RotationAngles(model.RotationIncrement.azimuth, n_1)]));
            }, increment_2)];
        }
        else {
            const increment_1 = model.RotationIncrement.azimuth;
            const patternInput_8 = (angle >= 0) ? [angle, "RAO"] : ((angle < 0) ? [Math.abs(angle), "LAO"] : [Number.NaN, "?"]);
            return [mkStepperComponent(patternInput_8[0], patternInput_8[1]), mkIncrementer((adjustAngle) => {
                dispatchLocal(new LocalMsg(24, [new RotationAngles(adjustAngle(0)(increment_1), 0)]));
            }, (n) => {
                dispatchLocal(new LocalMsg(25, [new RotationAngles(n, model.RotationIncrement.elevation)]));
            }, increment_1)];
        }
    };
    const backToStudyButton = button(ofArray([new Option_1(0, [new Color_IColor(8, [])]), new Option_1(17, [ofArray([["style", {
        width: "100%",
        marginBottom: "0.5rem",
    }], new HTMLAttr(99, ["backToStudy"]), new HTMLAttr(158, ["Back to Study"]), new DOMAttr(40, [(_arg_6) => {
        dispatch(wrapOutboundMsg(new OutboundMsg(1, [])));
    }])])])]), singleton(Fa_i(singleton(new Fa_IconOption(11, ["fas fa-times-circle"])), [])));
    const deviceOptionButton = button(ofArray([new Option_1(0, [new Color_IColor(6, [])]), new Option_1(17, [ofArray([["style", {
        width: "100%",
    }], new DOMAttr(40, [(_arg_7) => {
        dispatchLocal(new LocalMsg(90, []));
    }])])])]), singleton("Device Options"));
    const group = (extraStyleProps, elements) => level(singleton(new Level_Option(0, [singleton(["style", keyValueList(toList(delay(() => append(singleton_1(new CSSProp(221, [0])), delay(() => extraStyleProps)))), 1)])])), elements);
    const patternInput_10 = mkAngleDisplayTool(new RotationAngle(0, []), model.RotationAngle.azimuth);
    const patternInput_11 = mkAngleDisplayTool(new RotationAngle(1, []), model.RotationAngle.elevation);
    let measurementsDropdown;
    const triggerStyles = (equals(model.LengthMeasurementState, new LengthMeasurementState(1, [])) ? true : equals(model.AngleMeasurementState, new AngleMeasurementState(1, []))) ? Shared_onButtonStyles : Shared_defaultButtonStyles;
    measurementsDropdown = dropdown(singleton(new Option_3(1, [])), ofArray([trigger(empty(), singleton(button(toList(delay(() => append(singleton_1(new Option_1(17, [ofArray([new HTMLAttr(158, ["Measurements"]), new HTMLAttr(159, ["button"])])])), delay(() => triggerStyles)))), singleton(icon_10(empty(), singleton(Fa_i(singleton(new Fa_IconOption(11, ["fas fa-pencil-ruler"])), []))))))), menu(empty(), singleton(content_1(empty(), ofArray([Item_button(ofArray([new Item_Option(0, [equals(model.LengthMeasurementState, new LengthMeasurementState(1, []))]), new Item_Option(1, [singleton(new DOMAttr(40, [(_arg_8) => {
        dispatchLocal(new LocalMsg(40, []));
    }]))])]), ofArray([icon_10(empty(), singleton(Fa_i(singleton(new Fa_IconOption(11, ["fas fa-ruler"])), []))), " Add Length Measurement"])), Item_button(ofArray([new Item_Option(0, [equals(model.AngleMeasurementState, new AngleMeasurementState(1, []))]), new Item_Option(1, [singleton(new DOMAttr(40, [(_arg_9) => {
        dispatchLocal(new LocalMsg(44, []));
    }]))])]), ofArray([icon_10(empty(), singleton(Fa_i(singleton(new Fa_IconOption(11, ["fas fa-drafting-compass"])), []))), " Add Angle Measurement"]))]))))]));
    const removeMeasurementButton = mkToolReactButton(dispatch, (equals(model.LengthMeasurementState, new LengthMeasurementState(2, [])) ? true : equals(model.AngleMeasurementState, new AngleMeasurementState(2, []))) ? Shared_onButtonStyles : Shared_defaultButtonStyles, new Fa_IconOption(11, ["fas fa-trash"]), new LocalMsg(48, []), false, false, "Remove Measurement");
    const createRevisionButton = button(ofArray([new Option_1(16, [(!model.CanCreateRevision ? true : model.ReanalysisSubmitted) ? true : model.IsEditingCprPoints]), new Option_1(17, [singleton(["style", {
        width: "100%",
    }])]), new Option_1(13, [model.UploadingRevision]), new Option_1(18, [(_arg_10) => {
        dispatchLocal(new LocalMsg(81, []));
    }])]), singleton("Create Revision"));
    const customReportButton = Tooltip_tooltip((model.MaybeActiveMeasurement != null) ? "Please confirm or cancel the active measurement" : "Please set the device options", singleton(new CSSProp(395, ["100%"])), (model.MaybeActiveMeasurement != null) ? true : (model.MaybeDeviceOptions == null), button(ofArray([new Option_1(0, [new Color_IColor(6, [])]), new Option_1(17, [ofArray([["style", {
        width: "100%",
    }], new DOMAttr(40, [(_arg_11) => {
        dispatchLocal(new LocalMsg(94, []));
    }])])]), new Option_1(16, [(model.MaybeActiveMeasurement != null) ? true : (model.MaybeDeviceOptions == null)])]), singleton("Reports")));
    const submitForReanalysisButton = button(ofArray([new Option_1(17, [singleton(["style", {
        marginLeft: "auto",
    }])]), new Option_1(0, [new Color_IColor(7, [])]), new Option_1(16, [(model.ReanalysisSubmitted ? true : !model.CanSubmitForReanalysis) ? true : model.IsEditingCprPoints]), new Option_1(17, [ofArray([new HTMLAttr(99, ["submitForReanalysis"]), new DOMAttr(40, [(_arg_12) => {
        dispatch(wrapLocalMsg(new LocalMsg(112, [true])));
    }])])])]), singleton("Submit for Reanalysis"));
    let verticalDivider;
    const props_20 = [new HTMLAttr(64, ["is-divider"]), ["style", {
        width: "1px",
        backgroundColor: "#ccc",
        marginLeft: "0.5rem",
        marginRight: "0.5rem",
    }]];
    verticalDivider = react.createElement("div", keyValueList(props_20, 1));
    const actionsDropdown = dropdown(ofArray([new Option_3(1, []), new Option_3(2, [])]), ofArray([trigger(empty(), singleton(button(empty(), singleton("Actions")))), menu(empty(), singleton(content_1(empty(), toList(delay(() => append(singleton_1(createRevisionButton), delay(() => append(singleton_1(deviceOptionButton), delay(() => append(canUserViewCustomStentReport(model.MaybeCurrentUser) ? singleton_1(customReportButton) : empty_1(), delay(() => singleton_1(submitForReanalysisButton))))))))))))]));
    const patientDetailsDropdown = dropdown(singleton(new Option_3(1, [])), ofArray([trigger(empty(), singleton(button(ofArray([new Option_1(0, [new Color_IColor(6, [])]), new Option_1(17, [singleton(["style", {
        marginBottom: "0.5rem",
        width: "100%",
    }])])]), singleton(icon_10(empty(), singleton(Fa_i(singleton(new Fa_IconOption(11, ["fas fa-info-circle"])), []))))))), menu(empty(), singleton(content_1(singleton(new Common_GenericOption(1, [singleton(new HTMLAttr(65, ["patient-details-dropdown-content"]))])), singleton(card(empty(), ofArray([header_1(empty(), singleton(Header_title(empty(), singleton("Patient Details")))), content_2(empty(), (patientViewModel = model.SelectedPatient, (arrangeContent = ((htmlProps, tag_11, value_17) => {
        let children_24;
        return content_3(singleton(new Option_6(2, [toList(delay(() => append(htmlProps, delay(() => singleton_1(["style", {
            overflowWrap: "anywhere",
        }])))))])), ofArray([(children_24 = [react.createElement("b", {}, `${tag_11}: `)], react.createElement("p", {}, ...children_24)), value_17]));
    }), ofArray([arrangeContent([], "Internal Patient ID", patientViewModel.id), arrangeContent([], "Created By", patientViewModel.createdByUserName), (arg_22 = toString(patientViewModel.dateCreated), arrangeContent([], "Date Created", arg_22)), (arg_25 = Controls_ExpandableText_render(defaultArg(patientViewModel.patientCreationNote, "(No note)"), 20, patientViewModel.id), arrangeContent([], "Patient Creation Note", arg_25))]))))]))))))]));
    const revisionsSelection = Tooltip_tooltip("Please confirm or cancel the active measurement", singleton(new CSSProp(395, ["100%"])), model.MaybeActiveMeasurement != null, mkRevisionSelect(dispatch, model.MaybeActiveMeasurement != null, defaultArg(model.Revisions, empty()), model.CurrentRevision, model.UiDataFileChecksum));
    const children_66 = [(props_64 = [new HTMLAttr(65, ["layout-view-grid"]), ["style", {
        gridTemplateRows: "auto auto",
        gridTemplateColumns: "auto auto auto auto auto auto auto auto auto auto auto auto auto auto auto auto auto auto auto auto auto",
    }]], (children_64 = toList(delay(() => append(singleton_1(react.createElement("div", {})), delay(() => append(singleton_1(react.createElement("div", {})), delay(() => append(singleton_1(react.createElement("div", {})), delay(() => append(singleton_1(react.createElement("div", {})), delay(() => append(singleton_1(react.createElement("div", {})), delay(() => append(singleton_1(react.createElement("div", {})), delay(() => append(singleton_1(patternInput_10[0]), delay(() => append(singleton_1(react.createElement("div", {})), delay(() => append(singleton_1(patternInput_11[0]), delay(() => append(singleton_1(react.createElement("div", {})), delay(() => {
        let arg_27;
        return append(singleton_1((arg_27 = ofArray([mkSnapTopAngleButton(new Fa_IconOption(15, ["fas fa-a"]), (_arg_13) => {
            dispatchLocal(new LocalMsg(23, [new RotationAngles(0, 0)]));
        }), mkSnapTopAngleButton(new Fa_IconOption(15, ["fas fa-p"]), (_arg_14) => {
            dispatchLocal(new LocalMsg(23, [new RotationAngles(180, 0)]));
        })]), group([], arg_27))), delay(() => append(singleton_1(react.createElement("div", {})), delay(() => append(singleton_1(react.createElement("div", {})), delay(() => append(singleton_1(react.createElement("div", {})), delay(() => append(singleton_1(react.createElement("div", {})), delay(() => append(singleton_1(react.createElement("div", {})), delay(() => append(singleton_1(react.createElement("div", {})), delay(() => append(singleton_1(react.createElement("div", {})), delay(() => append(singleton_1(react.createElement("div", {})), delay(() => append(singleton_1(react.createElement("div", {})), delay(() => append(singleton_1(react.createElement("div", {})), delay(() => append(singleton_1(group([new CSSProp(110, ["0.5rem"])], ofArray([backToStudyButton, patientDetailsDropdown]))), delay(() => append(singleton_1(verticalDivider), delay(() => append(singleton_1(group([], singleton(stentPlanningTool))), delay(() => append(singleton_1(group([], ofArray([centerlineTool, slicePlaneTool, crosshairTool, zoomScrollToggle, maximizeViewportButton, customScreenshotButton]))), delay(() => append(singleton_1(verticalDivider), delay(() => append(singleton_1(react.createElement("div", {})), delay(() => append(singleton_1(group([], singleton(patternInput_10[1]))), delay(() => append(singleton_1(verticalDivider), delay(() => append(singleton_1(group([], singleton(patternInput_11[1]))), delay(() => append(singleton_1(verticalDivider), delay(() => {
            let arg_39;
            return append(singleton_1((arg_39 = ofArray([mkSnapTopAngleButton(new Fa_IconOption(15, ["fas fa-l"]), (_arg_15) => {
                dispatchLocal(new LocalMsg(23, [new RotationAngles(-90, 0)]));
            }), mkSnapTopAngleButton(new Fa_IconOption(15, ["fas fa-r"]), (_arg_16) => {
                dispatchLocal(new LocalMsg(23, [new RotationAngles(90, 0)]));
            })]), group([], arg_39))), delay(() => append(singleton_1(group([], singleton(mkResetCameraButton))), delay(() => append(singleton_1(verticalDivider), delay(() => append(singleton_1(group([], ofArray([measurementsDropdown, removeMeasurementButton, windowLevelButton]))), delay(() => append(singleton_1(verticalDivider), delay(() => append(singleton_1(group([], singleton(editModeControl))), delay(() => append(singleton_1(verticalDivider), delay(() => append(singleton_1(group([], singleton(actionsDropdown))), delay(() => append(singleton_1(group([], singleton(revisionsSelection))), delay(() => singleton_1(mkViewModeSelect(dispatch, false, StentPlanningViewMode_get_all(), [], model.ViewMode))))))))))))))))))));
        }))))))))))))))))))))))))))))))))))))))))));
    })))))))))))))))))))))), react.createElement("div", keyValueList(props_64, 1), ...children_64)))];
    return react.createElement("div", {
        className: "visualization-toolbar",
    }, ...children_66);
}

export function getBranchFromCenterlineMeasurement(centerlineMeasurement) {
    switch (centerlineMeasurement.tag) {
        case 0:
            return new Visualization_UnifiedBranch(0, [centerlineMeasurement.fields[0][0].branch]);
        case 2:
            return new Visualization_UnifiedBranch(0, [Visualization_UnifiedTransitionBranch_get_toDistance()(centerlineMeasurement.fields[0][0].branch)]);
        default:
            throw new Error("Unsupported measurement type");
    }
}

export function mkAxialSlider(dispatch, planeIdentifier, sliderIndex, maybeMeshes, dicomViewMode, disabled) {
    const children = [mkVerticalPlaneSlider((idx) => {
        dispatch(new LocalMsg(7, [dicomViewMode, wrapInboundMsg(new InboundMsg(5, [new DicomViewMode(0, []), map((m) => m.CurrentStudy, maybeMeshes), idx]))]));
    }, disabled, planeIdentifier, sliderIndex)];
    return react.createElement("div", {
        className: "vertical-slider vertical-slider--axial",
    }, ...children);
}

/**
 * Dispatches the messages needed to move a measurement plane to an absolute index.
 * Shared by the vertical plane slider and by dragging the CPR guide lines.
 */
export function dispatchPlaneIndexChange(dispatch, branch, enablePainting, planeIdentifier, idx) {
    dispatch(new LocalMsg(6, [wrapInboundMsg(new InboundMsg_1(2, [planeIdentifier, idx]))]));
    const patternInput = (planeIdentifier.tag === 0) ? [idx, undefined] : ((planeIdentifier.tag === 1) ? [undefined, idx] : [undefined, undefined]);
    dispatch(new LocalMsg(27, [branch, patternInput[0], patternInput[1], enablePainting]));
}

export function mkPlaneSlider(dispatch, planeIdentifier, sliderIndex, branch, enablePainting) {
    const planeCssClass = (planeIdentifier.tag === 0) ? "vertical-slider--plane-a" : ((planeIdentifier.tag === 1) ? "vertical-slider--plane-b" : "");
    const children = [mkVerticalPlaneSlider((idx) => {
        dispatchPlaneIndexChange(dispatch, branch, enablePainting, planeIdentifier, idx);
    }, false, planeIdentifier, sliderIndex)];
    return react.createElement("div", {
        className: `vertical-slider ${planeCssClass}`,
    }, ...children);
}

export function mkText(label, value) {
    return Split_View_makeHorizontalField(label, false, react.createElement("b", {}, value));
}

export class PlaneSliders extends Record {
    constructor(PlaneASlider, PlaneBSlider) {
        super();
        this.PlaneASlider = PlaneASlider;
        this.PlaneBSlider = PlaneBSlider;
    }
}

export function PlaneSliders_$reflection() {
    return record_type("Client.Visualization.StentPlanning.View.PlaneSliders", [], PlaneSliders, () => [["PlaneASlider", class_type("Fable.React.ReactElement")], ["PlaneBSlider", class_type("Fable.React.ReactElement")]]);
}

export function PlaneSliders_get_empty() {
    return new PlaneSliders(Helpers_nothing, Helpers_nothing);
}

export function mkPlaneSliders(dispatch, updater, activeMeasurement, maybeMeshes, enablePainting) {
    const bounds = StentMeasurement_getBounds(updater, activeMeasurement);
    const branch = getBranchFromCenterlineMeasurement(StentMeasurement__get_centerlineMeasurement(activeMeasurement));
    switch (activeMeasurement.tag) {
        case 0:
            return new PlaneSliders(mkPlaneSlider(dispatch, new Bindings_PlaneIdentifier(0, []), new SliderIndex(activeMeasurement.fields[1][0].index, "ltr", FSharpMap__get_Item(bounds, new Bindings_PlaneIdentifier(0, []))), branch, enablePainting), Helpers_nothing);
        case 1:
        case 2:
        case 4:
        case 5:
            return new PlaneSliders(Helpers_nothing, Helpers_nothing);
        default: {
            const vm = activeMeasurement.fields[1][0];
            const firstSliderIndex = new SliderIndex(vm.firstIndex, "ltr", FSharpMap__get_Item(bounds, new Bindings_PlaneIdentifier(0, [])));
            const secondSliderIndex = new SliderIndex(vm.secondIndex, "ltr", FSharpMap__get_Item(bounds, new Bindings_PlaneIdentifier(1, [])));
            return new PlaneSliders(mkPlaneSlider(dispatch, new Bindings_PlaneIdentifier(0, []), firstSliderIndex, branch, enablePainting), mkPlaneSlider(dispatch, new Bindings_PlaneIdentifier(1, []), secondSliderIndex, branch, enablePainting));
        }
    }
}

export const accelerateScroll = (() => {
    let lastWheelTime = now_1();
    let wheelEventCount = 0;
    return (delta) => {
        const now = utcNow();
        if (op_Subtraction(now, lastWheelTime) < 80) {
            wheelEventCount = ((wheelEventCount + 1) | 0);
        }
        else {
            wheelEventCount = 1;
        }
        lastWheelTime = now;
        const step = (1 * min(wheelEventCount, 20)) | 0;
        return ((delta < 0) ? op_UnaryNegation_Int32(step) : ((delta > 0) ? step : 0)) | 0;
    };
})();

export function deviceOptionModal(model, dispatch) {
    const dispatchLocal = mkDispatchLocal(dispatch);
    let devices_1;
    const matchValue = model.MaybeDeviceOptions;
    if (matchValue != null) {
        devices_1 = matchValue;
    }
    else {
        const ipsilateralLeft = DeviceOptionViewModel_get_empty();
        devices_1 = (new DeviceOptionsViewModel(model.SelectedStudy.studyId, DeviceOptionViewModel_get_empty(), ipsilateralLeft));
    }
    const mkDeviceOptionBox = (deviceOption, deviceOptionSetter, header) => box$0027(empty(), ofArray([h4(empty())(singleton(header)), div(empty(), ofArray([label_4(empty(), singleton("Trunk")), div_1(empty(), singleton(input(ofArray([new Option_2(1, [new IInputType(0, [])]), new Option_2(8, [deviceOption.trunk]), new Option_2(13, [(event) => {
        dispatchLocal(new LocalMsg(93, [deviceOptionSetter(new DeviceOptionViewModel(event.target.value, deviceOption.contralateral, deviceOption.additionalRight, deviceOption.additionalLeft))]));
    }]), new Option_2(12, ["No device found..."])]))))])), div(empty(), ofArray([label_4(empty(), singleton("Contralateral")), div_1(empty(), singleton(input(ofArray([new Option_2(1, [new IInputType(0, [])]), new Option_2(8, [deviceOption.contralateral]), new Option_2(13, [(event_1) => {
        dispatchLocal(new LocalMsg(93, [deviceOptionSetter(new DeviceOptionViewModel(deviceOption.trunk, event_1.target.value, deviceOption.additionalRight, deviceOption.additionalLeft))]));
    }]), new Option_2(12, ["No device found..."])]))))])), div(empty(), ofArray([label_4(empty(), singleton("Additional Left")), div_1(empty(), singleton(input(ofArray([new Option_2(1, [new IInputType(0, [])]), new Option_2(8, [deviceOption.additionalLeft]), new Option_2(13, [(event_2) => {
        dispatchLocal(new LocalMsg(93, [deviceOptionSetter(new DeviceOptionViewModel(deviceOption.trunk, deviceOption.contralateral, deviceOption.additionalRight, event_2.target.value))]));
    }]), new Option_2(12, ["No device found..."])]))))])), div(empty(), ofArray([label_4(empty(), singleton("Additional Right")), div_1(empty(), singleton(input(ofArray([new Option_2(1, [new IInputType(0, [])]), new Option_2(8, [deviceOption.additionalRight]), new Option_2(13, [(event_3) => {
        dispatchLocal(new LocalMsg(93, [deviceOptionSetter(new DeviceOptionViewModel(deviceOption.trunk, deviceOption.contralateral, event_3.target.value, deviceOption.additionalLeft))]));
    }]), new Option_2(12, ["No device found..."])]))))]))]));
    return modal(singleton(new Option_7(1, [model.IsDeviceOptionsModalVisible])), ofArray([background(empty(), empty()), Card_card(empty(), ofArray([Card_head(empty(), singleton(Card_title(empty(), singleton("Device Options")))), Card_body(singleton(new Common_GenericOption(1, [singleton(["style", {
        overflowY: "scroll",
    }])])), ofArray([mkDeviceOptionBox(devices_1.ipsilateralLeft, (option) => ((devices_2) => (new DeviceOptionsViewModel(devices_2.studyId, devices_2.ipsilateralRight, option))), "Ipsilateral Left"), mkDeviceOptionBox(devices_1.ipsilateralRight, (option_1) => ((devices_3) => (new DeviceOptionsViewModel(devices_3.studyId, option_1, devices_3.ipsilateralLeft))), "Ipsilateral Right")])), Card_foot(empty(), ofArray([button(ofArray([new Option_1(0, [new Color_IColor(6, [])]), new Option_1(17, [ofArray([new HTMLAttr(159, ["button"]), new DOMAttr(40, [(_arg) => {
        dispatchLocal(new LocalMsg(92, [SimplifiedStentMeasurements_fromStentMeasurements_2650BC81(model.Measurements.Current)]));
    }])])])]), singleton("Calculate")), button(ofArray([new Option_1(0, [new Color_IColor(6, [])]), new Option_1(17, [ofArray([new HTMLAttr(159, ["button"]), new DOMAttr(40, [(_arg_1) => {
        dispatchLocal(new LocalMsg(88, []));
    }])])])]), singleton("Save")), button(ofArray([new Option_1(0, [new Color_IColor(8, [])]), new Option_1(17, [ofArray([new HTMLAttr(159, ["button"]), new DOMAttr(40, [(_arg_2) => {
        dispatchLocal(new LocalMsg(91, [false]));
    }])])])]), singleton("Cancel"))]))]))]));
}

export function stentPlanningView(imageData, model, dispatch) {
    let clo_8, clo_5, clo_2, f2_5, f2_6, matchValue_67, f2_7, f2_8, matchValue_68, props_32, children_29;
    const dispatchLocal = mkDispatchLocal(dispatch);
    const interactionProps = new InteractionModeProps(new InteractionMode(0, [new CommonInteractionMode(0, [])]), new InteractionView(0, []));
    const dispatchToggleHoverMsg = (dicomViewMode, isHovering) => {
        const matchValue = model.MaybeActiveMeasurement;
        let matchResult;
        if (model.IsSelectingViewport != null) {
            matchResult = 0;
        }
        else {
            switch (dicomViewMode.tag) {
                case 5: {
                    if (matchValue != null) {
                        matchResult = 0;
                    }
                    else {
                        matchResult = 1;
                    }
                    break;
                }
                case 6: {
                    if (matchValue != null) {
                        if (matchValue.tag === 3) {
                            matchResult = 0;
                        }
                        else {
                            matchResult = 1;
                        }
                    }
                    else {
                        matchResult = 1;
                    }
                    break;
                }
                default:
                    matchResult = 1;
            }
        }
        switch (matchResult) {
            case 0: {
                break;
            }
            case 1: {
                dispatchLocal(new LocalMsg(7, [dicomViewMode, wrapInboundMsg(new InboundMsg(2, [isHovering]))]));
                break;
            }
        }
    };
    const meshViewport = (toStyle, viewportIdentifier_1) => {
        const isStentPlanning = equals(viewportIdentifier_1, new StentPlanningViewportIdentifier(0, []));
        const viewportArgs = FSharpMap__get_Item(model.ViewportSelectedMap, viewportIdentifier_1);
        const props_2 = toList(delay(() => append(singleton_1(new HTMLAttr(99, [toString(viewportIdentifier_1)])), delay(() => append(singleton_1(new HTMLAttr(65, ["layout-view-view-container"])), delay(() => {
            let matchValue_4;
            return append(!isStentPlanning ? append((matchValue_4 = model.ViewMode, (matchValue_4.tag === 2) ? append(singleton_1(new DOMAttr(52, [(_arg_2) => {
                dispatchToggleHoverMsg(new DicomViewMode(0, []), model.IsSliceScroll);
            }])), delay(() => singleton_1(new DOMAttr(53, [(_arg_3) => {
                dispatchToggleHoverMsg(new DicomViewMode(0, []), false);
            }])))) : ((matchValue_4.tag === 1) ? (empty_1()) : append(singleton_1(new DOMAttr(52, [(_arg) => {
                dispatchToggleHoverMsg(model.SelectedDicomView, model.IsSliceScroll);
            }])), delay(() => singleton_1(new DOMAttr(53, [(_arg_1) => {
                dispatchToggleHoverMsg(model.SelectedDicomView, false);
            }])))))), delay(() => singleton_1(new DOMAttr(64, [(e) => {
                const matchValue_5 = model.ViewMode;
                const matchValue_6 = model.CenterlineMeasurementModel.MaybeSelectedPlaneIdentifier;
                const matchValue_7 = model.MaybeActiveMeasurement;
                let matchResult_1, p;
                if (matchValue_6 != null) {
                    if (matchValue_7 != null) {
                        switch (matchValue_7.tag) {
                            case 1:
                            case 2: {
                                matchResult_1 = 0;
                                break;
                            }
                            default:
                                switch (matchValue_5.tag) {
                                    case 1: {
                                        matchResult_1 = 1;
                                        p = matchValue_6;
                                        break;
                                    }
                                    case 2: {
                                        matchResult_1 = 2;
                                        break;
                                    }
                                    default: {
                                        matchResult_1 = 1;
                                        p = matchValue_6;
                                    }
                                }
                        }
                    }
                    else {
                        switch (matchValue_5.tag) {
                            case 1: {
                                matchResult_1 = 1;
                                p = matchValue_6;
                                break;
                            }
                            case 2: {
                                matchResult_1 = 2;
                                break;
                            }
                            default: {
                                matchResult_1 = 1;
                                p = matchValue_6;
                            }
                        }
                    }
                }
                else {
                    matchResult_1 = 0;
                }
                switch (matchResult_1) {
                    case 0: {
                        break;
                    }
                    case 1: {
                        dispatchLocal(new LocalMsg(19, [p, (e.deltaY < 0) ? -1 : 1]));
                        break;
                    }
                    case 2: {
                        dispatchLocal(new LocalMsg(7, [new DicomViewMode(0, []), wrapInboundMsg(new InboundMsg(1, [(e.deltaY < 0) ? 2 : -2]))]));
                        break;
                    }
                }
            }])))) : empty_1(), delay(() => singleton_1(["style", keyValueList(toList(delay(() => toStyle(viewportIdentifier_1))), 1)])));
        }))))));
        const children_1 = toList(delay(() => {
            let matchValue_9, _name, dist;
            const currentMeshes = map(Meshes_Current_3B5CE845, FSharpMap__get_Item(model.Meshes, viewportIdentifier_1));
            const stentPlanningCenterlinesProps = new StentPlanningCenterlinesProps((matchValue_9 = model.MaybeActiveMeasurement, (matchValue_9 != null) ? ((matchValue_9.tag === 3) ? ((_name = matchValue_9.fields[0], (dist = matchValue_9.fields[1], singleton_2(dist[0])))) : (new Array(0))) : (new Array(0))), toString(viewportIdentifier_1), ArrayNames_fieldDataArrayNames);
            let viewportFullscreenId;
            const matchValue_10 = model.ViewMode;
            let matchResult_2;
            switch (viewportIdentifier_1.tag) {
                case 0: {
                    matchResult_2 = 0;
                    break;
                }
                case 1: {
                    switch (matchValue_10.tag) {
                        case 0: {
                            matchResult_2 = 1;
                            break;
                        }
                        default:
                            matchResult_2 = 0;
                    }
                    break;
                }
                default:
                    matchResult_2 = 2;
            }
            switch (matchResult_2) {
                case 0: {
                    viewportFullscreenId = "1";
                    break;
                }
                case 1: {
                    viewportFullscreenId = "2";
                    break;
                }
                default:
                    viewportFullscreenId = "";
            }
            return append(singleton_1(button(ofArray([new Option_1(19, ["viewport-select-button"]), new Option_1(18, [(_arg_4) => {
                const matchValue_12 = model.MaybePendingActionForViewportSelection;
                if (matchValue_12 != null) {
                    matchValue_12(viewportIdentifier_1);
                }
            }]), new Option_1(17, [singleton(["style", keyValueList(toList(delay(() => (!isStentPlanning ? singleton_1(new CSSProp(404, [1])) : empty_1()))), 1)])]), new Option_1(20, [singleton(new Modifier_IModifier(24, [new Screen(0, []), !(model.IsSelectingViewport != null)]))])]), singleton(viewportFullscreenId))), delay(() => {
                let props_1;
                return append(singleton_1((props_1 = keyValueList(toList(delay(() => append(singleton_1(new MeshVisualizationProps(0, [toString(viewportIdentifier_1)])), delay(() => append(singleton_1(new MeshVisualizationProps(1, [currentMeshes])), delay(() => append(singleton_1(new MeshVisualizationProps(2, [undefined])), delay(() => append(singleton_1(new MeshVisualizationProps(14, [false])), delay(() => append(singleton_1(new MeshVisualizationProps(4, [viewportArgs.map])), delay(() => append(singleton_1(new MeshVisualizationProps(5, [model.DisplayCenterline])), delay(() => append(singleton_1(new MeshVisualizationProps(6, [false])), delay(() => append(singleton_1(new VisualizationProps(1, [interactionProps])), delay(() => append(singleton_1(new MeshVisualizationProps(7, [(value_1) => {
                }])), delay(() => append(singleton_1(new MeshVisualizationProps(8, [new NotesProps(new Array(0), (x) => x, new Array(0), (value_2) => {
                })])), delay(() => append(singleton_1(new MeshVisualizationProps(9, [new NotesProps(new Array(0), (x_1) => x_1, new Array(0), (value_3) => {
                })])), delay(() => append(singleton_1(new MeshVisualizationProps(10, [ModelCamera_Props(viewportArgs.planeAdjustment, (arg) => {
                    dispatchLocal(new LocalMsg(5, [arg]));
                }, model.CameraModel)])), delay(() => append(singleton_1(new MeshVisualizationProps(12, [new CalipersProps([])])), delay(() => append(singleton_1(new MeshVisualizationProps(11, [ModelCenterlineMeasurement_Props_1DD22ABF(model.CenterlineMeasurementModel)])), delay(() => append(singleton_1(new VisualizationProps(0, [new ScreenshotProps((value_4) => {
                })])), delay(() => append(singleton_1(new MeshVisualizationProps(3, [toArray_1(delay(() => {
                    const matchValue_13 = model.ViewMode;
                    let matchResult_3;
                    if (viewportIdentifier_1.tag === 0) {
                        matchResult_3 = 0;
                    }
                    else {
                        switch (matchValue_13.tag) {
                            case 1: {
                                matchResult_3 = 2;
                                break;
                            }
                            case 2: {
                                matchResult_3 = 3;
                                break;
                            }
                            default:
                                if (model.SelectedDicomView.tag === 0) {
                                    matchResult_3 = 1;
                                }
                                else {
                                    matchResult_3 = 2;
                                }
                        }
                    }
                    switch (matchResult_3) {
                        case 0: {
                            return empty_1();
                        }
                        case 1:
                            return singleton_1(ModelSlicePlane_Props_Z714BB56C(FSharpMap__get_Item(model.SlicePlaneModels, DicomViewMode_get_names().Axial)));
                        case 2:
                            return append(singleton_1(ModelSlicePlane_Props_Z714BB56C(FSharpMap__get_Item(model.SlicePlaneModels, DicomViewMode_get_names().CenterlinePlaneA))), delay(() => singleton_1(ModelSlicePlane_Props_Z714BB56C(FSharpMap__get_Item(model.SlicePlaneModels, DicomViewMode_get_names().CenterlinePlaneB)))));
                        default:
                            return append(singleton_1(ModelSlicePlane_Props_Z714BB56C(FSharpMap__get_Item(model.SlicePlaneModels, DicomViewMode_get_names().Axial))), delay(() => append(singleton_1(ModelSlicePlane_Props_Z714BB56C(FSharpMap__get_Item(model.SlicePlaneModels, DicomViewMode_get_names().Coronal))), delay(() => singleton_1(ModelSlicePlane_Props_Z714BB56C(FSharpMap__get_Item(model.SlicePlaneModels, DicomViewMode_get_names().Sagittal)))))));
                    }
                }))])), delay(() => append(singleton_1(new MeshVisualizationProps(15, [ModelPickedMapValue_Props(model.PickedMapValueModel, new ViewportLocation(1, [viewportIdentifier_1]), (arg_1) => {
                    dispatchLocal(new LocalMsg(9, [arg_1]));
                })])), delay(() => append(singleton_1(new MeshVisualizationProps(16, [new ViewportLocation(1, [viewportIdentifier_1])])), delay(() => append(singleton_1(new MeshVisualizationProps(17, [model.IsSliceScroll])), delay(() => {
                    let matchValue_16;
                    return append(singleton_1(new MeshVisualizationProps(18, [(matchValue_16 = model.SelectedDicomView, (matchValue_16.tag === 0) ? ((delta_2) => {
                        dispatchLocal(new LocalMsg(7, [model.SelectedDicomView, wrapInboundMsg(new InboundMsg(1, [-delta_2]))]));
                    }) : ((matchValue_16.tag === 5) ? ((delta_3) => {
                        dispatchLocal(new LocalMsg(29, [model.SelectedDicomView, delta_3]));
                    }) : ((value_5) => {
                    })))])), delay(() => append(singleton_1(new MeshVisualizationProps(19, [isStentPlanning])), delay(() => append(singleton_1(new MeshVisualizationProps(20, [true])), delay(() => append(singleton_1(new MeshVisualizationProps(21, [stentPlanningCenterlinesProps])), delay(() => append(singleton_1(new MeshVisualizationProps(22, [new StentPlanningProps(model.SelectedStudy.studyId, ArrayNames_fieldDataArrayNames, Array.from(values(model.Measurements.Current)), model.MaybeActiveMeasurement, (label) => {
                        dispatchLocal(new LocalMsg(13, [label]));
                    }, stentPlanningEventNames)])), delay(() => append(!isStentPlanning ? singleton_1(new MeshVisualizationProps(13, [ModelAnatomyOrientation_Props_Z550008EC(model.AnatomyOrientationModel)])) : empty_1(), delay(() => {
                        let viewportIdentifier, matchValue_3;
                        return append(singleton_1(new MeshVisualizationProps(23, [(viewportIdentifier = viewportIdentifier_1, (matchValue_3 = model.ViewMode, (matchValue_3.tag === 2) ? (equals(viewportIdentifier, new StentPlanningViewportIdentifier(0, [])) ? false : ((model.MaximizedViewport == null) ? true : equals(model.MaximizedViewport, viewportIdentifier))) : ((matchValue_3.tag === 1) ? (equals(viewportIdentifier, new StentPlanningViewportIdentifier(0, [])) ? false : ((model.MaximizedViewport == null) ? true : equals(model.MaximizedViewport, viewportIdentifier))) : ((model.MaximizedViewport == null) ? true : equals(model.MaximizedViewport, viewportIdentifier)))))])), delay(() => append(singleton_1(new MeshVisualizationProps(24, [(arg_2) => {
                            dispatchLocal(new LocalMsg(21, [arg_2]));
                        }])), delay(() => append(singleton_1(new MeshVisualizationProps(25, [eventNames])), delay(() => append(singleton_1(new MeshVisualizationProps(26, [model.SelectedDicomView])), delay(() => singleton_1(new MeshVisualizationProps(27, [(tupledArg) => {
                            dispatch(wrapOutboundMsg(new OutboundMsg(2, [tupledArg[0], tupledArg[1]])));
                        }]))))))))));
                    }))))))))))));
                })))))))))))))))))))))))))))))))))))))))), 1), react.createElement(MeshVisualization, props_1))), delay(() => (!isStentPlanning ? append(singleton_1(mkViewportToolPanel([mkMapSelect(dispatch, viewportIdentifier_1, new StentPlanningViewMode(0, []), model.AvailableMaps, viewportArgs.map)])), delay(() => singleton_1(mkMeasurementButtons(dispatch, model)))) : empty_1())));
            }));
        }));
        return react.createElement("div", keyValueList(props_2, 1), ...children_1);
    };
    let patternInput;
    const gridDiv = (rows) => ((cols) => {
        const props_4 = ofArray([new HTMLAttr(65, ["layout-view-grid"]), ["style", {
            gridTemplateRows: rows,
            gridTemplateColumns: cols,
            overflowY: "hidden",
        }]]);
        return (children_3) => react.createElement("div", keyValueList(props_4, 1), ...children_3);
    });
    let hiddenDiv;
    const props_7 = singleton(["style", {
        overflowY: "hidden",
        height: "100%",
        minHeight: "0",
    }]);
    hiddenDiv = ((children_6) => react.createElement("div", keyValueList(props_7, 1), ...children_6));
    let fullHeightDiv;
    const props_10 = singleton(["style", {
        height: "100%",
        minHeight: "0",
    }]);
    fullHeightDiv = ((children_9) => react.createElement("div", keyValueList(props_10, 1), ...children_9));
    const matchValue_21 = model.MaximizedViewport;
    let matchResult_4, vm;
    if (matchValue_21 == null) {
        matchResult_4 = 2;
        vm = model.ViewMode;
    }
    else {
        switch (matchValue_21.tag) {
            case 2:
            case 8:
            case 9: {
                matchResult_4 = 0;
                break;
            }
            default:
                matchResult_4 = 1;
        }
    }
    switch (matchResult_4) {
        case 0: {
            patternInput = ["", fullHeightDiv];
            break;
        }
        case 1: {
            patternInput = ["", (children_12) => react.createElement("div", {}, ...children_12)];
            break;
        }
        default: {
            const viewMode = vm;
            patternInput = ((viewMode.tag === 2) ? ["1fr 1fr 1fr 1fr", hiddenDiv] : ((viewMode.tag === 1) ? ["1fr 1fr 1fr 1fr", (clo_8 = gridDiv("1fr 1fr")("1fr"), clo_8)] : ((model.MaybeActiveMeasurement != null) ? ["1fr 1fr 1fr", (clo_5 = gridDiv("1fr 1fr")("1fr"), clo_5)] : ((model.SelectedDicomView.tag === 0) ? ["1fr 1fr 1fr", (clo_2 = gridDiv("1fr")("1fr"), clo_2)] : ["1fr 1fr 1fr", (clo_5 = gridDiv("1fr 1fr")("1fr"), clo_5)]))));
        }
    }
    const getMeshViewportStyle = (viewportIdentifier_3) => {
        let viewportIdentifier_2, matchValue_23, matchValue_24, viewport_1;
        const style = (viewportIdentifier_3.tag === 0) ? ((!equals(model.ViewMode, new StentPlanningViewMode(0, [])) && !equals(model.MaximizedViewport, viewportIdentifier_3)) ? ofArray([new CSSProp(291, ["absolute"]), new CSSProp(395, ["33.33%"]), new CSSProp(189, ["100%"]), new CSSProp(251, ["0"]), new CSSProp(33, ["4px solid"]), new CSSProp(404, [3])]) : ofArray([new CSSProp(189, ["100%"]), new CSSProp(251, ["0"])])) : ofArray([new CSSProp(189, ["100%"]), new CSSProp(251, ["0"])]);
        return cons(new CSSProp(125, [(viewportIdentifier_2 = viewportIdentifier_3, (matchValue_23 = model.MaximizedViewport, (matchValue_23 == null) ? ((matchValue_24 = model.ViewMode, (matchValue_24.tag === 1) ? (equals(viewportIdentifier_2, new StentPlanningViewportIdentifier(0, [])) ? (model.IsStentPlanningVisible ? "block" : "none") : "block") : ((matchValue_24.tag === 2) ? (equals(viewportIdentifier_2, new StentPlanningViewportIdentifier(0, [])) ? (model.IsStentPlanningVisible ? "block" : "none") : "block") : "block"))) : (equals(matchValue_23, viewportIdentifier_2) ? ((viewport_1 = matchValue_23, "block")) : (((equals(viewportIdentifier_2, new StentPlanningViewportIdentifier(0, [])) && model.IsStentPlanningVisible) && !equals(model.ViewMode, new StentPlanningViewMode(0, []))) ? "block" : "none"))))]), style);
    };
    let gridContainerStyle;
    if (model.IsCapturingStentPlanScreenshots && (model.MaximizedViewport != null)) {
        gridContainerStyle = [["style", {
            width: "1200px",
            height: "1634px",
            position: "relative",
        }]];
    }
    else if (model.IsCapturingViewportScreenshots && (model.MaximizedViewport != null)) {
        let patternInput_1;
        const matchValue_26 = model.MaximizedViewport;
        let matchResult_5;
        if (matchValue_26 != null) {
            switch (matchValue_26.tag) {
                case 6:
                case 7: {
                    matchResult_5 = 0;
                    break;
                }
                case 8:
                case 9: {
                    matchResult_5 = 1;
                    break;
                }
                case 0: {
                    matchResult_5 = 2;
                    break;
                }
                case 3: {
                    matchResult_5 = 3;
                    break;
                }
                case 2: {
                    matchResult_5 = 4;
                    break;
                }
                default:
                    matchResult_5 = 5;
            }
        }
        else {
            matchResult_5 = 5;
        }
        switch (matchResult_5) {
            case 0: {
                patternInput_1 = [572, 1062];
                break;
            }
            case 1: {
                patternInput_1 = [572, 572];
                break;
            }
            case 2: {
                patternInput_1 = [800, 1634];
                break;
            }
            case 3: {
                patternInput_1 = [800, 572];
                break;
            }
            case 4: {
                patternInput_1 = ((model.SelectedDicomView.tag === 5) ? [572, 572] : [800, 572]);
                break;
            }
            default:
                patternInput_1 = [572, 572];
        }
        gridContainerStyle = [["style", {
            width: toText(interpolate("%d%P()px", [patternInput_1[0]])),
            height: toText(interpolate("%d%P()px", [patternInput_1[1]])),
            position: "relative",
        }]];
    }
    else {
        gridContainerStyle = ((model.MaximizedViewport == null) ? [new HTMLAttr(65, ["layout-view-grid"]), ["style", {
            position: "relative",
            gridTemplateRows: "1fr",
            gridTemplateColumns: patternInput[0],
        }]] : [["style", {
            height: "100%",
            minHeight: "0",
            position: "relative",
        }]]);
    }
    let planeSliders;
    const matchValue_28 = model.MaybeActiveMeasurement;
    let matchResult_6, measurement;
    if (matchValue_28 == null) {
        matchResult_6 = 0;
    }
    else {
        switch (matchValue_28.tag) {
            case 5:
            case 4: {
                matchResult_6 = 0;
                break;
            }
            default: {
                matchResult_6 = 1;
                measurement = matchValue_28;
            }
        }
    }
    switch (matchResult_6) {
        case 0: {
            planeSliders = PlaneSliders_get_empty();
            break;
        }
        default:
            planeSliders = mkPlaneSliders(dispatchLocal, model.CenterlineMeasurementModel.CenterlineData.CenterlinePlaneUpdater, measurement, FSharpMap__get_Item(model.Meshes, new StentPlanningViewportIdentifier(1, [])), model.SegmentationProps.paintingEnabled);
    }
    const dicomViewport = (getDisplayOption, dicomView, viewportId_1) => {
        const files = defaultArg(map(ImageData_StandardImageFiles__43A3F7B7, imageData), new Array(0));
        const displayOption = getDisplayOption(dicomView);
        let maybeCenterlineScrollHandler;
        switch (dicomView.tag) {
            case 5:
            case 6: {
                const matchValue_29 = model.MaybeActiveMeasurement;
                let matchResult_7;
                if (matchValue_29 != null) {
                    switch (matchValue_29.tag) {
                        case 0: {
                            if (dicomView.tag === 6) {
                                matchResult_7 = 0;
                            }
                            else {
                                matchResult_7 = 2;
                            }
                            break;
                        }
                        case 1: {
                            if (dicomView.tag === 6) {
                                matchResult_7 = 0;
                            }
                            else {
                                matchResult_7 = 1;
                            }
                            break;
                        }
                        case 2: {
                            if (dicomView.tag === 6) {
                                matchResult_7 = 0;
                            }
                            else {
                                matchResult_7 = 1;
                            }
                            break;
                        }
                        default:
                            matchResult_7 = 2;
                    }
                }
                else {
                    matchResult_7 = 0;
                }
                switch (matchResult_7) {
                    case 0: {
                        maybeCenterlineScrollHandler = ((delta_4) => {
                            dispatchLocal(new LocalMsg(29, [dicomView, delta_4]));
                        });
                        break;
                    }
                    case 1: {
                        maybeCenterlineScrollHandler = ((value_7) => {
                        });
                        break;
                    }
                    default: {
                        const activePlane = (dicomView.tag === 5) ? (new Bindings_PlaneIdentifier(0, [])) : ((dicomView.tag === 6) ? (new Bindings_PlaneIdentifier(1, [])) : defaultArg(model.CenterlineMeasurementModel.MaybeSelectedPlaneIdentifier, new Bindings_PlaneIdentifier(0, [])));
                        maybeCenterlineScrollHandler = ((delta_5) => {
                            dispatchLocal(new LocalMsg(19, [activePlane, ~~Math.ceil(delta_5)]));
                        });
                    }
                }
                break;
            }
            default:
                maybeCenterlineScrollHandler = undefined;
        }
        const addedMeasurementCallback = (_arg_5) => {
            dispatchLocal(new LocalMsg(42, []));
        };
        const removedMeasurementCallback = (dicomLengthMeasurementId) => {
            dispatchLocal(new LocalMsg(43, [dicomLengthMeasurementId]));
        };
        const addedAngleMeasurementCallback = (_arg_6) => {
            dispatchLocal(new LocalMsg(46, []));
        };
        const removedAngleMeasurementCallback = (dicomAngleMeasurementId) => {
            dispatchLocal(new LocalMsg(47, [dicomAngleMeasurementId]));
        };
        const slicingMode = (dicomView.tag === 1) ? (new SlicingMode(1, [])) : ((dicomView.tag === 2) ? (new SlicingMode(2, [])) : (new SlicingMode(0, [])));
        let measurementPlacementOwner;
        const matchValue_31 = model.MeasurementPlacementOwner;
        measurementPlacementOwner = ((matchValue_31 == null) ? defaultOf() : ((matchValue_31.tag === 1) ? "Coronal" : ((matchValue_31.tag === 2) ? "Sagittal" : "Axial")));
        const placementStartedCallback = () => {
            dispatchLocal(new LocalMsg(49, [dicomView]));
        };
        let activeSegmentation;
        const matchValue_32 = model.MaybeActiveMeasurement;
        let matchResult_8;
        if (dicomView.tag === 6) {
            if (matchValue_32 != null) {
                if (matchValue_32.tag === 3) {
                    matchResult_8 = 0;
                }
                else {
                    matchResult_8 = 1;
                }
            }
            else {
                matchResult_8 = 1;
            }
        }
        else {
            matchResult_8 = 1;
        }
        switch (matchResult_8) {
            case 0: {
                activeSegmentation = model.BottomPlaneActiveSegmentation;
                break;
            }
            default:
                activeSegmentation = model.ActiveSegmentation;
        }
        const modifedSegmentations = DicomViewMode_get_isCenterline()(dicomView) ? model.ModifiedCenterlineSegmentations : model.ModifiedAxialSegmentations;
        const centerlineSegmentationChangedCallback = (idx, data) => {
            dispatchLocal(new LocalMsg(54, [idx, data, activeSegmentation]));
        };
        const props_20 = [new DOMAttr(52, [(_arg_7) => {
            dispatchToggleHoverMsg(dicomView, true);
        }]), new DOMAttr(53, [(_arg_8) => {
            dispatchToggleHoverMsg(dicomView, false);
        }]), new HTMLAttr(65, ["dicom-container"]), ["style", {
            display: displayOption,
        }], new HTMLAttr(99, [viewportId_1])];
        const children_17 = toList(delay(() => {
            let matchValue_35, selectedBranch, matchValue_36, unifiedBranchIndex, props_17, matchValue_37, matchValue_38, props_19;
            return append((matchValue_35 = dicomView, (matchValue_35.tag === 5) ? ((selectedBranch = ((matchValue_36 = model.SelectedCprBranch, (matchValue_36.tag === 0) ? matchValue_36.fields[0] : (new Visualization_UnifiedDistanceBranch(0, [])))), (unifiedBranchIndex = map((tupledArg_1) => tupledArg_1[1], FSharpMap__get_Item(model.SlicePlaneModels, DicomViewMode_get_describe()(dicomView)).MaybeUnifiedBranchIndex), singleton_1((props_17 = {
                viewportId: viewportId_1,
                dicomFiles: files,
                dicomMaskFiles: defaultArg(map((activeSegmentation.tag === 0) ? (ImageData_LumenMasks__43A3F7B7) : ((activeSegmentation.tag === 1) ? (ImageData_WallMasks__43A3F7B7) : ((_arg_10) => (new Array(0)))), imageData), new Array(0)),
                showMasks: model.ShowMasks,
                wallCenterline: unwrap(map((meshes) => meshes.CurrentStudy.wallCenterline.dataSource, FSharpMap__get_Item(model.Meshes, new StentPlanningViewportIdentifier(1, [])))),
                selectedBranch: selectedBranch,
                sliceIndex: unwrap(unifiedBranchIndex),
                segmentationColor: (matchValue_37 = model.MaybeActiveMeasurement, (matchValue_38 = model.CenterlineMeasurementModel.MaybeSelectedPlaneIdentifier, (dicomView.tag === 5) ? (new SegmentationColor(1, [])) : ((dicomView.tag === 6) ? (new SegmentationColor(0, [])) : ((matchValue_37 != null) ? ((matchValue_37.tag === 3) ? ((matchValue_38 != null) ? ((matchValue_38.tag === 0) ? (new SegmentationColor(1, [])) : ((matchValue_38.tag === 1) ? (new SegmentationColor(0, [])) : (new SegmentationColor(0, [])))) : (new SegmentationColor(0, []))) : (new SegmentationColor(0, []))) : (new SegmentationColor(0, [])))))),
                onCenterlineSliceScroll: unwrap(maybeCenterlineScrollHandler),
                onTouchStart: (e_1) => {
                    if (e_1.touches.length === 1) {
                        dispatchToggleHoverMsg(dicomView, true);
                    }
                },
                onTouchEnd: (_arg_11) => {
                    dispatchToggleHoverMsg(dicomView, false);
                },
                interactionModeProps: interactionProps,
                screenshotProps: new ScreenshotProps((value_11) => {
                }),
                isSliceScroll: model.IsSliceScroll,
                dicomLoader: model.ImageLoader,
                isVisible: displayOption !== "none",
                segmentationProps: model.SegmentationProps,
                isEditable: (dicomView.tag === 5) ? true : (dicomView.tag === 6),
                isCenterlineEditable: equals(model.ActiveEditMode, new StentEditMode(1, [])),
                activeWidget: unwrap(model.MaybeActiveWidget),
                activeMeasurement: unwrap(model.MaybeActiveMeasurement),
                lengthProps: new LengthPropsModel(toArray_2(model.DicomLengthMeasurementIds), model.LengthMeasurementState, measurementPlacementOwner, placementStartedCallback, addedMeasurementCallback, removedMeasurementCallback),
                angleProps: new AnglePropsModel(toArray_2(model.DicomAngleMeasurementIds), model.AngleMeasurementState, measurementPlacementOwner, placementStartedCallback, addedAngleMeasurementCallback, removedAngleMeasurementCallback),
                centerlineSegmentationChangedCallback: centerlineSegmentationChangedCallback,
                modifiedSegmentations: toArray_3(FSharpMap__get_Item(modifedSegmentations, activeSegmentation)),
                eventNames: cprEventNames,
                dicomEventNames: dicomEventNames,
                onVisualizationReady: (tupledArg_2) => {
                    dispatch(wrapOutboundMsg(new OutboundMsg(2, [tupledArg_2[0], tupledArg_2[1]])));
                },
            }, react.createElement(OrthogonalCprVisualization, props_17)))))) : ((matchValue_35.tag === 6) ? ((selectedBranch = ((matchValue_36 = model.SelectedCprBranch, (matchValue_36.tag === 0) ? matchValue_36.fields[0] : (new Visualization_UnifiedDistanceBranch(0, [])))), (unifiedBranchIndex = map((tupledArg_1) => tupledArg_1[1], FSharpMap__get_Item(model.SlicePlaneModels, DicomViewMode_get_describe()(dicomView)).MaybeUnifiedBranchIndex), singleton_1((props_17 = {
                viewportId: viewportId_1,
                dicomFiles: files,
                dicomMaskFiles: defaultArg(map((activeSegmentation.tag === 0) ? (ImageData_LumenMasks__43A3F7B7) : ((activeSegmentation.tag === 1) ? (ImageData_WallMasks__43A3F7B7) : ((_arg_10) => (new Array(0)))), imageData), new Array(0)),
                showMasks: model.ShowMasks,
                wallCenterline: unwrap(map((meshes) => meshes.CurrentStudy.wallCenterline.dataSource, FSharpMap__get_Item(model.Meshes, new StentPlanningViewportIdentifier(1, [])))),
                selectedBranch: selectedBranch,
                sliceIndex: unwrap(unifiedBranchIndex),
                segmentationColor: (matchValue_37 = model.MaybeActiveMeasurement, (matchValue_38 = model.CenterlineMeasurementModel.MaybeSelectedPlaneIdentifier, (dicomView.tag === 5) ? (new SegmentationColor(1, [])) : ((dicomView.tag === 6) ? (new SegmentationColor(0, [])) : ((matchValue_37 != null) ? ((matchValue_37.tag === 3) ? ((matchValue_38 != null) ? ((matchValue_38.tag === 0) ? (new SegmentationColor(1, [])) : ((matchValue_38.tag === 1) ? (new SegmentationColor(0, [])) : (new SegmentationColor(0, [])))) : (new SegmentationColor(0, []))) : (new SegmentationColor(0, []))) : (new SegmentationColor(0, [])))))),
                onCenterlineSliceScroll: unwrap(maybeCenterlineScrollHandler),
                onTouchStart: (e_1) => {
                    if (e_1.touches.length === 1) {
                        dispatchToggleHoverMsg(dicomView, true);
                    }
                },
                onTouchEnd: (_arg_11) => {
                    dispatchToggleHoverMsg(dicomView, false);
                },
                interactionModeProps: interactionProps,
                screenshotProps: new ScreenshotProps((value_11) => {
                }),
                isSliceScroll: model.IsSliceScroll,
                dicomLoader: model.ImageLoader,
                isVisible: displayOption !== "none",
                segmentationProps: model.SegmentationProps,
                isEditable: (dicomView.tag === 5) ? true : (dicomView.tag === 6),
                isCenterlineEditable: equals(model.ActiveEditMode, new StentEditMode(1, [])),
                activeWidget: unwrap(model.MaybeActiveWidget),
                activeMeasurement: unwrap(model.MaybeActiveMeasurement),
                lengthProps: new LengthPropsModel(toArray_2(model.DicomLengthMeasurementIds), model.LengthMeasurementState, measurementPlacementOwner, placementStartedCallback, addedMeasurementCallback, removedMeasurementCallback),
                angleProps: new AnglePropsModel(toArray_2(model.DicomAngleMeasurementIds), model.AngleMeasurementState, measurementPlacementOwner, placementStartedCallback, addedAngleMeasurementCallback, removedAngleMeasurementCallback),
                centerlineSegmentationChangedCallback: centerlineSegmentationChangedCallback,
                modifiedSegmentations: toArray_3(FSharpMap__get_Item(modifedSegmentations, activeSegmentation)),
                eventNames: cprEventNames,
                dicomEventNames: dicomEventNames,
                onVisualizationReady: (tupledArg_2) => {
                    dispatch(wrapOutboundMsg(new OutboundMsg(2, [tupledArg_2[0], tupledArg_2[1]])));
                },
            }, react.createElement(OrthogonalCprVisualization, props_17)))))) : singleton_1((props_19 = keyValueList(toList(delay(() => append(singleton_1(new DicomVisualizationProps(0, [viewportId_1])), delay(() => append(singleton_1(new DicomVisualizationProps(1, [files])), delay(() => append(singleton_1(new DicomVisualizationProps(3, [ActiveSegmentation_get_describe()(activeSegmentation)])), delay(() => append(singleton_1(new DicomVisualizationProps(2, [defaultArg(map((dicomView.tag === 0) ? ((activeSegmentation.tag === 1) ? (ImageData_WallMasks__43A3F7B7) : ((activeSegmentation.tag === 2) ? (ImageData_VisceralMasks__43A3F7B7) : (ImageData_LumenMasks__43A3F7B7))) : ((dicomView.tag === 1) ? ((activeSegmentation.tag === 1) ? (ImageData_WallMasks__43A3F7B7) : ((activeSegmentation.tag === 2) ? (ImageData_VisceralMasks__43A3F7B7) : (ImageData_LumenMasks__43A3F7B7))) : ((dicomView.tag === 2) ? ((activeSegmentation.tag === 1) ? (ImageData_WallMasks__43A3F7B7) : ((activeSegmentation.tag === 2) ? (ImageData_VisceralMasks__43A3F7B7) : (ImageData_LumenMasks__43A3F7B7))) : ((_arg_12) => (new Array(0))))), imageData), new Array(0))])), delay(() => append(singleton_1(new DicomVisualizationProps(4, [model.ShowMasks])), delay(() => {
                let matchValue_41;
                return append((matchValue_41 = dicomView, (matchValue_41.tag === 0) ? singleton_1(new DicomVisualizationProps(5, [(sliceValue) => {
                    dispatchLocal(new LocalMsg(7, [dicomView, wrapInboundMsg(new InboundMsg(0, [sliceValue]))]));
                }])) : ((matchValue_41.tag === 1) ? singleton_1(new DicomVisualizationProps(5, [(sliceValue) => {
                    dispatchLocal(new LocalMsg(7, [dicomView, wrapInboundMsg(new InboundMsg(0, [sliceValue]))]));
                }])) : ((matchValue_41.tag === 2) ? singleton_1(new DicomVisualizationProps(5, [(sliceValue) => {
                    dispatchLocal(new LocalMsg(7, [dicomView, wrapInboundMsg(new InboundMsg(0, [sliceValue]))]));
                }])) : (empty_1())))), delay(() => append(singleton_1(new DicomVisualizationProps(6, [maybeCenterlineScrollHandler])), delay(() => append(singleton_1(new DicomVisualizationProps(7, [(e_2) => {
                    if (e_2.touches.length === 1) {
                        dispatchToggleHoverMsg(dicomView, true);
                    }
                }])), delay(() => append(singleton_1(new DicomVisualizationProps(8, [(_arg_13) => {
                    dispatchToggleHoverMsg(dicomView, false);
                }])), delay(() => append(singleton_1(new VisualizationProps(1, [interactionProps])), delay(() => append(singleton_1(new VisualizationProps(0, [new ScreenshotProps((value_13) => {
                })])), delay(() => append(singleton_1(new DicomVisualizationProps(9, [model.IsSliceScroll])), delay(() => append(singleton_1(new DicomVisualizationProps(10, [FSharpMap__get_Item(model.SlicePlaneModels, DicomViewMode_get_describe()(dicomView)).Index])), delay(() => append(singleton_1(new DicomVisualizationProps(11, [false])), delay(() => append(singleton_1(new DicomVisualizationProps(12, [model.SegmentationProps])), delay(() => {
                    let matchValue_42, matchValue_43;
                    return append(singleton_1(new DicomVisualizationProps(13, [(matchValue_42 = model.MaybeActiveMeasurement, (matchValue_43 = model.CenterlineMeasurementModel.MaybeSelectedPlaneIdentifier, (matchValue_42 != null) ? ((matchValue_42.tag === 3) ? ((matchValue_43 != null) ? ((matchValue_43.tag === 0) ? (new SegmentationColor(1, [])) : ((matchValue_43.tag === 1) ? (new SegmentationColor(0, [])) : (new SegmentationColor(0, [])))) : (new SegmentationColor(0, []))) : (new SegmentationColor(0, []))) : (new SegmentationColor(0, []))))])), delay(() => append(singleton_1(new DicomVisualizationProps(21, [centerlineSegmentationChangedCallback])), delay(() => append(singleton_1(new DicomVisualizationProps(22, [(idx_1, data_1) => {
                        dispatchLocal(new LocalMsg(55, [idx_1, data_1]));
                    }])), delay(() => append(singleton_1(new DicomVisualizationProps(23, [(slices) => {
                        dispatchLocal(new LocalMsg(56, [slices]));
                    }])), delay(() => append(singleton_1(new DicomVisualizationProps(14, [new LengthPropsModel(toArray_2(model.DicomLengthMeasurementIds), model.LengthMeasurementState, measurementPlacementOwner, placementStartedCallback, addedMeasurementCallback, removedMeasurementCallback)])), delay(() => append(singleton_1(new DicomVisualizationProps(15, [new AnglePropsModel(toArray_2(model.DicomAngleMeasurementIds), model.AngleMeasurementState, measurementPlacementOwner, placementStartedCallback, addedAngleMeasurementCallback, removedAngleMeasurementCallback)])), delay(() => append(singleton_1(new DicomVisualizationProps(16, [displayOption !== "none"])), delay(() => append(singleton_1(new DicomVisualizationProps(17, [slicingMode])), delay(() => append(singleton_1(new DicomVisualizationProps(18, [model.MaybeActiveWidget])), delay(() => append(singleton_1(new DicomVisualizationProps(19, [model.MaybeActiveMeasurement])), delay(() => append(singleton_1(new DicomVisualizationProps(20, [model.CrosshairsWidgetFactory])), delay(() => append(singleton_1(new DicomVisualizationProps(24, [dicomEventNames])), delay(() => append(singleton_1(new DicomVisualizationProps(25, [model.ImageLoader])), delay(() => append(singleton_1(new DicomVisualizationProps(27, [toArray_3(FSharpMap__get_Item(modifedSegmentations, activeSegmentation))])), delay(() => append(singleton_1(new DicomVisualizationProps(26, [(arg_12) => {
                        dispatchLocal(new LocalMsg(117, [arg_12]));
                    }])), delay(() => singleton_1(new DicomVisualizationProps(28, [(tupledArg_3) => {
                        dispatch(wrapOutboundMsg(new OutboundMsg(2, [tupledArg_3[0], tupledArg_3[1]])));
                    }]))))))))))))))))))))))))))))))));
                }))))))))))))))))))));
            })))))))))))), 1), react.createElement(DicomVisualization, props_19))))), delay(() => {
                const matchValue_45 = dicomView;
                switch (matchValue_45.tag) {
                    case 5:
                        return singleton_1(planeSliders.PlaneASlider);
                    case 6:
                        return singleton_1(planeSliders.PlaneBSlider);
                    case 0: {
                        const matchValue_46 = model.AxialBounds;
                        if (matchValue_46 == null) {
                            return singleton_1(Helpers_nothing);
                        }
                        else {
                            const bounds = matchValue_46;
                            const sliderIndex = new SliderIndex(~~defaultArg(FSharpMap__get_Item(model.SlicePlaneModels, DicomViewMode_get_describe()(new DicomViewMode(0, []))).Index, 0), "rtl", bounds);
                            const isPlacingMeasurement = equals(model.LengthMeasurementState, new LengthMeasurementState(1, [])) ? true : equals(model.AngleMeasurementState, new AngleMeasurementState(1, []));
                            return singleton_1(mkAxialSlider(dispatchLocal, new Bindings_PlaneIdentifier(0, []), sliderIndex, FSharpMap__get_Item(model.Meshes, new StentPlanningViewportIdentifier(1, [])), new DicomViewMode(0, []), isPlacingMeasurement));
                        }
                    }
                    default:
                        return singleton_1(Helpers_nothing);
                }
            }));
        }));
        return react.createElement("div", keyValueList(props_20, 1), ...children_17);
    };
    const cprDicomViewport = (getDisplayOption_1, dicomView_2, viewportId_4) => {
        const files_1 = defaultArg((dicomView_2.tag === 4) ? ((dicomView_2.fields[0].tag === 0) ? map(ImageData_StandardImageFiles__43A3F7B7, imageData) : ((console.error(some("Only distance branches are supported when initializing the StraightenedCpr view.")), undefined))) : map(ImageData_StandardImageFiles__43A3F7B7, imageData), new Array(0));
        const displayOption_1 = getDisplayOption_1(dicomView_2);
        let cprViewMode;
        switch (dicomView_2.tag) {
            case 3: {
                cprViewMode = (new CprViewMode(0, []));
                break;
            }
            case 4: {
                cprViewMode = (new CprViewMode(1, []));
                break;
            }
            default: {
                console.warn(some("Unexpected DicomViewMode for CPR viewport:"), dicomView_2);
                cprViewMode = (new CprViewMode(0, []));
            }
        }
        let selectedBranch_1;
        const matchValue_47 = model.SelectedCprBranch;
        selectedBranch_1 = ((matchValue_47.tag === 0) ? matchValue_47.fields[0] : (new Visualization_UnifiedDistanceBranch(0, [])));
        const props_28 = [new DOMAttr(52, [(_arg_14) => {
            dispatchToggleHoverMsg(dicomView_2, true);
        }]), new DOMAttr(53, [(_arg_15) => {
            dispatchToggleHoverMsg(dicomView_2, false);
        }]), new HTMLAttr(65, ["dicom-container"]), ["style", {
            display: displayOption_1,
        }], new DOMAttr(64, [(e_3) => {
            if (model.IsSliceScroll) {
                const scaledDelta = (accelerateScroll(e_3.deltaY) * 1) | 0;
                dispatchLocal(new LocalMsg(52, [dicomView_2, (FSharpMap__get_Item(model.ObliqueAngleState, DicomViewMode_get_describe()(dicomView_2)).Angle + scaledDelta) % (360 * 1)]));
            }
        }])];
        const children_24 = toList(delay(() => {
            let props_27;
            return append(singleton_1((props_27 = keyValueList(toList(delay(() => append(singleton_1(new CprVisualizationProps(0, [viewportId_4])), delay(() => append(singleton_1(new CprVisualizationProps(1, [cprViewMode])), delay(() => append(singleton_1(new CprVisualizationProps(3, [files_1])), delay(() => append(singleton_1(new CprVisualizationProps(4, [(e_4) => {
                if (e_4.touches.length === 1) {
                    dispatchToggleHoverMsg(dicomView_2, true);
                }
            }])), delay(() => append(singleton_1(new CprVisualizationProps(5, [(_arg_16) => {
                dispatchToggleHoverMsg(dicomView_2, false);
            }])), delay(() => append(singleton_1(new VisualizationProps(1, [interactionProps])), delay(() => append(singleton_1(new VisualizationProps(0, [new ScreenshotProps((value_19) => {
            })])), delay(() => append(singleton_1(new CprVisualizationProps(6, [model.IsSliceScroll])), delay(() => append(singleton_1(new CprVisualizationProps(2, [selectedBranch_1])), delay(() => append(singleton_1(new CprVisualizationProps(9, [displayOption_1 !== "none"])), delay(() => append(singleton_1(new CprVisualizationProps(7, [FSharpMap__get_Item(model.ObliqueAngleState, DicomViewMode_get_describe()(dicomView_2)).Angle])), delay(() => append(singleton_1(new CprVisualizationProps(8, [(angleInDegrees) => {
                dispatchLocal(new LocalMsg(52, [dicomView_2, ~~round(angleInDegrees) * 1]));
            }])), delay(() => {
                let matchValue_48;
                return append((matchValue_48 = dicomView_2, (matchValue_48.tag === 3) ? singleton_1(new CprVisualizationProps(10, [map((meshes_1) => meshes_1.CurrentStudy.wallCenterline.dataSource, FSharpMap__get_Item(model.Meshes, new StentPlanningViewportIdentifier(1, [])))])) : ((matchValue_48.tag === 4) ? singleton_1(new CprVisualizationProps(10, [map((meshes_1) => meshes_1.CurrentStudy.wallCenterline.dataSource, FSharpMap__get_Item(model.Meshes, new StentPlanningViewportIdentifier(1, [])))])) : (empty_1()))), delay(() => append(singleton_1(new CprVisualizationProps(11, [() => {
                    dispatchLocal(new LocalMsg(77, []));
                }])), delay(() => append(singleton_1(new CprVisualizationProps(12, [cprEventNames])), delay(() => append(singleton_1(new CprVisualizationProps(13, [model.CprControlPointMode])), delay(() => append(singleton_1(new CprVisualizationProps(22, [equals(model.ActiveEditMode, new StentEditMode(1, []))])), delay(() => append(singleton_1(new CprVisualizationProps(14, [model.ImageLoader])), delay(() => append(singleton_1(new CprVisualizationProps(15, [(vtpContent) => {
                    dispatchLocal(new LocalMsg(83, [vtpContent]));
                }])), delay(() => append(singleton_1(new CprVisualizationProps(0, [viewportId_4])), delay(() => append(singleton_1(new CprVisualizationProps(16, [model.MaybeActiveMeasurement])), delay(() => append(singleton_1(new CprVisualizationProps(17, [(tupledArg_4) => {
                    const matchValue_49 = model.MaybeActiveMeasurement;
                    if (matchValue_49 == null) {
                    }
                    else {
                        const planeIdentifier = (tupledArg_4[0] === "end") ? (new Bindings_PlaneIdentifier(1, [])) : (new Bindings_PlaneIdentifier(0, []));
                        const matchValue_50 = tryFind(planeIdentifier, StentMeasurement_getBounds(model.CenterlineMeasurementModel.CenterlineData.CenterlinePlaneUpdater, matchValue_49));
                        if (matchValue_50 == null) {
                        }
                        else {
                            const planeBounds = matchValue_50;
                            dispatchPlaneIndexChange(dispatchLocal, model.SelectedCprBranch, model.SegmentationProps.paintingEnabled, planeIdentifier, min(planeBounds.lastIndex, max(planeBounds.firstIndex, tupledArg_4[1])));
                        }
                    }
                }])), delay(() => append(singleton_1(new CprVisualizationProps(18, [(controlPointsJson) => {
                    dispatchLocal(new LocalMsg(84, [controlPointsJson]));
                }])), delay(() => append((dicomView_2.tag === 3) ? singleton_1(new CprVisualizationProps(19, [() => {
                    dispatchLocal(new LocalMsg(85, []));
                }])) : (empty_1()), delay(() => singleton_1(new CprVisualizationProps(20, [(tupledArg_5) => {
                    dispatch(wrapOutboundMsg(new OutboundMsg(2, [tupledArg_5[0], tupledArg_5[1]])));
                }]))))))))))))))))))))))))));
            })))))))))))))))))))))))))), 1), react.createElement(CprVisualization, props_27))), delay(() => {
                let matchValue_52;
                return append((matchValue_52 = dicomView_2, (matchValue_52.tag === 5) ? singleton_1(planeSliders.PlaneASlider) : ((matchValue_52.tag === 6) ? singleton_1(planeSliders.PlaneBSlider) : singleton_1(Helpers_nothing))), delay(() => {
                    let dicomView_1, displayAngle, onChange, props_24, children_21, children_19;
                    const matchValue_53 = dicomView_2;
                    switch (matchValue_53.tag) {
                        case 3:
                        case 4:
                            return singleton_1((dicomView_1 = dicomView_2, (displayAngle = ((((FSharpMap__get_Item(model.ObliqueAngleState, DicomViewMode_get_describe()(dicomView_1)).Angle % 360) + 360) % 360) | 0), (onChange = FormField_onChangeNumberDispatch((maybeAngle) => {
                                iterate((angle) => {
                                    dispatchLocal(new LocalMsg(52, [dicomView_1, angle * 1]));
                                }, toArray(maybeAngle));
                            }, displayAngle), (props_24 = [new HTMLAttr(65, ["cpr-angle-slider"]), new HTMLAttr(158, [toText(interpolate("Oblique angle: %d%P()°", [displayAngle]))])], (children_21 = [FormField_slider(0, 359, 1, int32ToString(displayAngle), [new HTMLAttr(64, ["horizontal-slider"])], [], onChange), (children_19 = [toText(interpolate("%d%P()°", [displayAngle]))], react.createElement("span", {
                                className: "cpr-angle-slider__value",
                            }, ...children_19))], react.createElement("div", keyValueList(props_24, 1), ...children_21)))))));
                        default:
                            return singleton_1(Helpers_nothing);
                    }
                }));
            }));
        }));
        return react.createElement("div", keyValueList(props_28, 1), ...children_24);
    };
    const getMainDicomViewportDisplayOption = (viewportIdentifier_4, dicomView_3) => {
        const matchValue_54 = model.SelectedDicomView;
        let matchResult_9;
        switch (dicomView_3.tag) {
            case 0: {
                if (matchValue_54.tag === 0) {
                    matchResult_9 = 0;
                }
                else {
                    matchResult_9 = 1;
                }
                break;
            }
            case 5: {
                if (matchValue_54.tag === 5) {
                    matchResult_9 = 0;
                }
                else {
                    matchResult_9 = 1;
                }
                break;
            }
            case 6: {
                if (matchValue_54.tag === 6) {
                    matchResult_9 = 0;
                }
                else {
                    matchResult_9 = 1;
                }
                break;
            }
            default:
                matchResult_9 = 1;
        }
        switch (matchResult_9) {
            case 0: {
                const matchValue_56 = model.MaximizedViewport;
                if (matchValue_56 != null) {
                    if (equals(matchValue_56, viewportIdentifier_4)) {
                        const viewport_3 = matchValue_56;
                        return "block";
                    }
                    else {
                        return "none";
                    }
                }
                else {
                    return "block";
                }
            }
            default:
                return "none";
        }
    };
    const getCprDicomViewportDisplayOption = (viewportIdentifier_5, dicomView_4) => {
        let isEquivalentTransitionBranch;
        const matchValue_57 = model.SelectedCprBranch;
        let matchResult_10;
        switch (dicomView_4.tag) {
            case 4: {
                if (dicomView_4.fields[0].tag === 0) {
                    switch (dicomView_4.fields[0].fields[0].tag) {
                        case 0: {
                            if (matchValue_57.tag === 1) {
                                if (matchValue_57.fields[0].tag === 0) {
                                    matchResult_10 = 0;
                                }
                                else {
                                    matchResult_10 = 1;
                                }
                            }
                            else {
                                matchResult_10 = 1;
                            }
                            break;
                        }
                        case 1: {
                            if (matchValue_57.tag === 1) {
                                if (matchValue_57.fields[0].tag === 1) {
                                    matchResult_10 = 0;
                                }
                                else {
                                    matchResult_10 = 1;
                                }
                            }
                            else {
                                matchResult_10 = 1;
                            }
                            break;
                        }
                        default:
                            matchResult_10 = 1;
                    }
                }
                else {
                    matchResult_10 = 1;
                }
                break;
            }
            case 3: {
                if (dicomView_4.fields[0].tag === 0) {
                    switch (dicomView_4.fields[0].fields[0].tag) {
                        case 0: {
                            if (matchValue_57.tag === 1) {
                                if (matchValue_57.fields[0].tag === 0) {
                                    matchResult_10 = 0;
                                }
                                else {
                                    matchResult_10 = 1;
                                }
                            }
                            else {
                                matchResult_10 = 1;
                            }
                            break;
                        }
                        case 1: {
                            if (matchValue_57.tag === 1) {
                                if (matchValue_57.fields[0].tag === 1) {
                                    matchResult_10 = 0;
                                }
                                else {
                                    matchResult_10 = 1;
                                }
                            }
                            else {
                                matchResult_10 = 1;
                            }
                            break;
                        }
                        default:
                            matchResult_10 = 1;
                    }
                }
                else {
                    matchResult_10 = 1;
                }
                break;
            }
            default:
                matchResult_10 = 1;
        }
        switch (matchResult_10) {
            case 0: {
                isEquivalentTransitionBranch = true;
                break;
            }
            default:
                isEquivalentTransitionBranch = false;
        }
        let matchResult_11;
        if (model.ViewMode.tag === 1) {
            if ((equals(dicomView_4, new DicomViewMode(4, [model.SelectedCprBranch])) ? true : equals(dicomView_4, new DicomViewMode(3, [model.SelectedCprBranch]))) ? true : isEquivalentTransitionBranch) {
                matchResult_11 = 0;
            }
            else {
                matchResult_11 = 1;
            }
        }
        else {
            matchResult_11 = 1;
        }
        switch (matchResult_11) {
            case 0: {
                const matchValue_60 = model.MaximizedViewport;
                if (matchValue_60 != null) {
                    if (equals(matchValue_60, viewportIdentifier_5)) {
                        const viewport_5 = matchValue_60;
                        return "block";
                    }
                    else {
                        return "none";
                    }
                }
                else {
                    return "block";
                }
            }
            default:
                return "none";
        }
    };
    const getCprDicomViewportDisplayOptionFlipped = (dicomView_5, a) => Functions_flip(getCprDicomViewportDisplayOption, dicomView_5, a);
    const getCprCenterlinePlaneViewportDisplayOption = (viewportIdentifier_6, unitVar_111) => {
        const matchValue_61 = model.ViewMode;
        let matchResult_12;
        switch (matchValue_61.tag) {
            case 0: {
                if (equals(model.SelectedDicomView, new DicomViewMode(0, []))) {
                    matchResult_12 = 0;
                }
                else {
                    matchResult_12 = 1;
                }
                break;
            }
            case 1: {
                matchResult_12 = 1;
                break;
            }
            default:
                matchResult_12 = 2;
        }
        switch (matchResult_12) {
            case 0:
                return "none";
            case 1: {
                const matchValue_62 = model.MaximizedViewport;
                if (matchValue_62 != null) {
                    if (equals(matchValue_62, viewportIdentifier_6)) {
                        const viewport_7 = matchValue_62;
                        return "block";
                    }
                    else {
                        return "none";
                    }
                }
                else {
                    return "block";
                }
            }
            default:
                return "none";
        }
    };
    const getMprDicomViewportDisplayOption = (viewportIdentifier_7, unitVar_112) => {
        if (model.ViewMode.tag === 2) {
            const matchValue_64 = model.MaximizedViewport;
            if (matchValue_64 != null) {
                if (equals(matchValue_64, viewportIdentifier_7)) {
                    const viewport_9 = matchValue_64;
                    return "block";
                }
                else {
                    return "none";
                }
            }
            else {
                return "block";
            }
        }
        else {
            return "none";
        }
    };
    const getMprDicomViewportDisplayOptionFlipped = (a_2) => Functions_flip(getMprDicomViewportDisplayOption, undefined, a_2);
    let getAxialViewportDisplayOption;
    const matchValue_65 = model.ViewMode;
    switch (matchValue_65.tag) {
        case 2: {
            const f2_4 = curry2(getMprDicomViewportDisplayOption)(new StentPlanningViewportIdentifier(2, []));
            getAxialViewportDisplayOption = ((arg_13) => f2_4(void arg_13));
            break;
        }
        case 1: {
            getAxialViewportDisplayOption = ((_arg_17) => "none");
            break;
        }
        default:
            getAxialViewportDisplayOption = curry2(getMainDicomViewportDisplayOption)(new StentPlanningViewportIdentifier(2, []));
    }
    const withViewportSelector = (buttonContent, getDisplayOption_2, viewportIdentifier_8, children_26) => {
        const props_30 = [new HTMLAttr(65, ["layout-view-view-container"]), ["style", {
            display: getDisplayOption_2(viewportIdentifier_8),
            height: "100%",
            zIndex: 1,
        }]];
        const children_27 = toList(delay(() => append(singleton_1(button(ofArray([new Option_1(19, ["viewport-select-button"]), new Option_1(18, [(_arg_18) => {
            const matchValue_66 = model.MaybePendingActionForViewportSelection;
            if (matchValue_66 != null) {
                matchValue_66(viewportIdentifier_8);
            }
        }]), new Option_1(20, [singleton(new Modifier_IModifier(24, [new Screen(0, []), !(model.IsSelectingViewport != null)]))])]), singleton(buttonContent))), delay(() => children_26))));
        return react.createElement("div", keyValueList(props_30, 1), ...children_27);
    };
    let stretchedCprViewport;
    const arg_15 = curry2(getCprDicomViewportDisplayOptionFlipped)(new DicomViewMode(3, [model.SelectedCprBranch]));
    const arg_17 = singleton(cprDicomViewport(curry2(getCprDicomViewportDisplayOption)(new StentPlanningViewportIdentifier(6, [])), new DicomViewMode(3, [model.SelectedCprBranch]), toString(new StentPlanningViewportIdentifier(6, []))));
    stretchedCprViewport = withViewportSelector("2", arg_15, new StentPlanningViewportIdentifier(6, []), arg_17);
    const mkStraightenedCprViewport = (branch_3) => {
        const arg_19 = curry2(getCprDicomViewportDisplayOptionFlipped)(new DicomViewMode(4, [branch_3]));
        const arg_21 = singleton(cprDicomViewport(curry2(getCprDicomViewportDisplayOption)(new StentPlanningViewportIdentifier(7, [])), new DicomViewMode(4, [branch_3]), `${toString(new StentPlanningViewportIdentifier(7, []))}_${Visualization_UnifiedBranch_get_describe()(branch_3)}`));
        return withViewportSelector("3", arg_19, new StentPlanningViewportIdentifier(7, []), arg_21);
    };
    const straightenedCprCuspViewport = mkStraightenedCprViewport(new Visualization_UnifiedBranch(0, [new Visualization_UnifiedDistanceBranch(2, [])]));
    const straightenedCprLeftViewport = mkStraightenedCprViewport(new Visualization_UnifiedBranch(0, [new Visualization_UnifiedDistanceBranch(0, [])]));
    const straightenedCprRightViewport = mkStraightenedCprViewport(new Visualization_UnifiedBranch(0, [new Visualization_UnifiedDistanceBranch(1, [])]));
    const centerlineDicomPlaneAViewport = dicomViewport((f2_5 = curry2(getCprCenterlinePlaneViewportDisplayOption)(new StentPlanningViewportIdentifier(2, [])), (arg_22) => f2_5(void arg_22)), new DicomViewMode(5, [new Visualization_UnifiedBranch(0, [new Visualization_UnifiedDistanceBranch(2, [])])]), toString(new StentPlanningViewportIdentifier(8, [])));
    let centerlineDicomPlaneBViewport;
    const arg_27 = singleton(dicomViewport((f2_6 = curry2(getCprCenterlinePlaneViewportDisplayOption)(new StentPlanningViewportIdentifier(9, [])), (arg_23) => f2_6(void arg_23)), new DicomViewMode(6, [new Visualization_UnifiedBranch(0, [new Visualization_UnifiedDistanceBranch(2, [])])]), toString(new StentPlanningViewportIdentifier(9, []))));
    centerlineDicomPlaneBViewport = withViewportSelector((matchValue_67 = model.ViewMode, (matchValue_67.tag === 1) ? "5" : ((matchValue_67.tag === 0) ? "4" : "")), (a_1) => Functions_flip(getCprCenterlinePlaneViewportDisplayOption, undefined, a_1), new StentPlanningViewportIdentifier(9, []), arg_27);
    const axialDicomViewport = dicomViewport(getAxialViewportDisplayOption, new DicomViewMode(0, []), toString(new StentPlanningViewportIdentifier(3, [])));
    let coronalDicomViewport;
    const arg_32 = singleton(dicomViewport((f2_7 = curry2(getMprDicomViewportDisplayOption)(new StentPlanningViewportIdentifier(4, [])), (arg_28) => f2_7(void arg_28)), new DicomViewMode(1, []), toString(new StentPlanningViewportIdentifier(4, []))));
    coronalDicomViewport = withViewportSelector("3", getMprDicomViewportDisplayOptionFlipped, new StentPlanningViewportIdentifier(4, []), arg_32);
    let sagittalDicomViewport;
    const arg_37 = singleton(dicomViewport((f2_8 = curry2(getMprDicomViewportDisplayOption)(new StentPlanningViewportIdentifier(5, [])), (arg_33) => f2_8(void arg_33)), new DicomViewMode(2, []), toString(new StentPlanningViewportIdentifier(5, []))));
    sagittalDicomViewport = withViewportSelector("4", getMprDicomViewportDisplayOptionFlipped, new StentPlanningViewportIdentifier(5, []), arg_37);
    let mainDicomViewport;
    const arg_41 = toList(delay(() => append(singleton_1(axialDicomViewport), delay(() => append(singleton_1(centerlineDicomPlaneAViewport), delay(() => (equals(model.ViewMode, new StentPlanningViewMode(0, [])) ? singleton_1(mkViewportToolPanel(toList(delay(() => {
        let _arg_19;
        return append(singleton_1(mkDicomSelect(dispatch, model.MaybeActiveMeasurement != null, [new DicomViewMode(0, []), new DicomViewMode(5, [new Visualization_UnifiedBranch(0, [new Visualization_UnifiedDistanceBranch(2, [])])])], (_arg_19 = model.SelectedDicomView, (_arg_19.tag === 5) ? (new DicomViewMode(5, [new Visualization_UnifiedBranch(0, [new Visualization_UnifiedDistanceBranch(2, [])])])) : _arg_19))), delay(() => {
            const matchValue_69 = model.SelectedDicomView;
            if (matchValue_69.tag === 5) {
                const branch_4 = matchValue_69.fields[0];
                return singleton_1(mkCenterlineDicomBranchSelect(dispatch, model.MaybeActiveMeasurement != null, Visualization_UnifiedBranch_get_all()(branch_4), branch_4));
            }
            else {
                return singleton_1(Helpers_nothing);
            }
        }));
    })))) : empty_1())))))));
    mainDicomViewport = withViewportSelector((matchValue_68 = model.ViewMode, (matchValue_68.tag === 0) ? "3" : ((matchValue_68.tag === 2) ? "2" : "4")), (a_3) => Functions_flip(getMainDicomViewportDisplayOption, model.SelectedDicomView, a_3), new StentPlanningViewportIdentifier(2, []), arg_41);
    const children_31 = [(props_32 = toList(delay(() => gridContainerStyle)), (children_29 = [meshViewport(getMeshViewportStyle, new StentPlanningViewportIdentifier(0, [])), meshViewport(getMeshViewportStyle, new StentPlanningViewportIdentifier(1, [])), stretchedCprViewport, straightenedCprCuspViewport, straightenedCprLeftViewport, straightenedCprRightViewport, patternInput[1](ofArray([mainDicomViewport, centerlineDicomPlaneBViewport])), coronalDicomViewport, sagittalDicomViewport, mkCenterlineButtons(dispatch, model)], react.createElement("div", keyValueList(props_32, 1), ...children_29)))];
    return react.createElement("div", {
        className: "viewports-height-correction",
    }, ...children_31);
}

export function submitForReanalysisModal(model, dispatch) {
    const hideModal = (_arg) => {
        dispatch(wrapLocalMsg(new LocalMsg(112, [false])));
    };
    return modal(singleton(new Option_7(1, [model.SubmitReanalysisModalVisible])), ofArray([background(singleton(new Common_GenericOption(1, [singleton(new DOMAttr(40, [hideModal]))])), empty()), Card_card(empty(), ofArray([Card_head(empty(), singleton("Submit For Re-Analysis")), Card_body(empty(), ofArray([react.createElement("div", {}, "Are you sure you want to submit the updated segmentations for re-analysis?"), react.createElement("div", {}, "You won\'t be able to view or make changes to this study until re-analysis is complete."), react.createElement("div", {}, "A new Revision will also be created for the current measurements.")])), Card_foot(empty(), ofArray([button(ofArray([new Option_1(0, [new Color_IColor(6, [])]), new Option_1(17, [singleton(new DOMAttr(40, [(_arg_1) => {
        dispatch(wrapLocalMsg(new LocalMsg(113, [])));
    }]))])]), singleton("Submit")), button(singleton(new Option_1(17, [singleton(new DOMAttr(40, [hideModal]))])), singleton("Cancel"))]))]))]));
}

export function reanalysisSubmitted(model, dispatch) {
    let children, s_1;
    return modal(singleton(new Option_7(1, [equals(model.SelectedStudy.status, new Common_StudyStatus(5, []))])), ofArray([background(empty(), empty()), Card_card(empty(), ofArray([Card_head(empty(), singleton("Study Has Been Submitted For Re-Analysis")), Card_body(empty(), singleton((children = [(s_1 = "This study has been submitted for re-analysis and will be locked until re-analysis is complete. You will now be returned to the study page.", s_1)], react.createElement("div", {}, ...children)))), Card_foot(empty(), singleton(button(ofArray([new Option_1(0, [new Color_IColor(6, [])]), new Option_1(17, [singleton(new DOMAttr(40, [(_arg) => {
        dispatch(wrapOutboundMsg(new OutboundMsg(1, [])));
    }]))])]), singleton("Ok"))))]))]));
}

export function view(loadingStatus, imageData, model, dispatch) {
    const children_4 = toList(delay(() => {
        let matchValue;
        return append((matchValue = loadingStatus, (matchValue.tag === 2) ? singleton_1(Controls_spinner("Extracting...")) : ((matchValue.tag === 3) ? singleton_1(Controls_spinner("Rendering...")) : ((matchValue.tag === 0) ? singleton_1(Helpers_nothing) : ((matchValue.tag === 4) ? singleton_1(Helpers_nothing) : singleton_1(Controls_spinner("Downloading...")))))), delay(() => {
            let props_2, children_2;
            return append(singleton_1((props_2 = [new HTMLAttr(65, ["visualization-dynamic-height"]), ["style", {
                gridColumn: 1,
                gridRow: 1,
                visibility: equals(loadingStatus, new LoadingStatus(4, [])) ? "visible" : "hidden",
            }]], (children_2 = toList(delay(() => append(singleton_1(mkMainToolPanel(imageData, model, dispatch)), delay(() => append(singleton_1(stentPlanningView(imageData, model, dispatch)), delay(() => append(singleton_1(deviceOptionModal(model, dispatch)), delay(() => {
                let props, children;
                return (model.IsCapturingStentPlanScreenshots ? true : model.IsCapturingViewportScreenshots) ? singleton_1((props = [["style", {
                    position: "fixed",
                    top: "0",
                    left: "0",
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(128, 128, 128, 1.0)",
                    zIndex: 9999,
                    cursor: "not-allowed",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }], new DOMAttr(40, [(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                }]), new DOMAttr(56, [(e_1) => {
                    e_1.preventDefault();
                    e_1.stopPropagation();
                }]), new DOMAttr(54, [(e_2) => {
                    e_2.preventDefault();
                    e_2.stopPropagation();
                }])], (children = [Controls_spinner("Capturing screenshots...")], react.createElement("div", keyValueList(props, 1), ...children)))) : empty_1();
            })))))))), react.createElement("div", keyValueList(props_2, 1), ...children_2)))), delay(() => append(singleton_1(submitForReanalysisModal(model, dispatch)), delay(() => append(singleton_1(reanalysisSubmitted(model, dispatch)), delay(() => singleton_1(screenshotModal(model.ScreenshotModalModel, (arg_1) => {
                dispatch(wrapLocalMsg(new LocalMsg(108, [arg_1])));
            }, false))))))));
        }));
    }));
    return react.createElement(react.Fragment, {}, ...children_4);
}

